// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:06.739Z
// Property: Villas of Waterford (ID: 6767906449166550)
// Collections: 29 amenities, 4 floorplans (live), 40 photos, 73 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166550",
  "property_external_id": "118085",
  "property_zillow_url": "https://www.zillow.com/apartments/wichita-ks/villas-of-waterford/5ZbKcq/",
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Villas+of+Waterford+Apartments/data=!4m2!3m1!1s0x0:0xc4a8404ec3b733f4?sa=X&ved=2ahUKEwis7I7ThL2SAxVvJkQIHdbLOAsQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "villas-of-waterford",
  "property_name": "Villas of Waterford",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/villas-of-waterford/",
  "property_domain": null,
  "property_address": "8510 E. 29th St. N.",
  "property_full_address": "8510 E. 29th St. N., Wichita, KS, 67226",
  "property_address_1": "8510 E. 29th St. N.",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67226",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": null,
  "property_address_latitude": "37.7386",
  "property_address_longitude": "-97.2383",
  "property_email": "villaswaterford@caseusa.com",
  "property_phone": "(316) 227-1796",
  "property_call_tracking_phone": "844-345-3558",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Villas of Waterford in Wichita, KS, every detail is designed for your lifestyle. Enjoy two sparkling outdoor pools, a state-of-the-art fitness center, and a cozy Grill & Chill area. With spacious one and two-bedroom floor plans, you’ll find the perfect blend of comfort and luxury. Begin your new chapter today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Villas of Waterford – Your Perfect Home in Wichita, KS!**\n\nDiscover the ideal living experience at Villas of Waterford, where modern comfort meets exceptional amenities. Our diverse floor plans offer spacious One-Bedroom and Two-Bedroom apartments, providing options to fit your lifestyle. Each apartment features stylish finishes, including *vaulted ceilings, hardwood floors,* and *plush carpeting,* designed for your ultimate comfort.\n\nStep outside and enjoy our two inviting outdoor swimming pools, perfect for lounging on warm days. Stay active at our onsite fitness center or relax by the cozy *Grill & Chill area with a fireplace,* ideal for gatherings with friends and family. For those with little ones, our onsite playground guarantees hours of fun. Connect with neighbors at the resident clubhouse, a welcoming space for socializing and community events. \n\nVillas of Waterford offers paramount convenience with features such as package receiving, limited-access gates for added security, and 24-hour emergency maintenance. Additional perks include online rental payments and flexible payment options to suit your needs. Plus, as a pet-friendly community, your furry friends are welcome here!\n\nLocated conveniently close to K-96, Kellogg, and I-35, Villas of Waterford ensures easy access to shopping, dining, and entertainment in Wichita. Experience a lifestyle where comfort and community come together.\n\nDon’t wait any longer! Find your new home today—browse our availability or schedule a tour to visit our vibrant community at Villas of Waterford! Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db8df-7c66-724c-bb1b-7a3c92620a3e.webp",
  "property_featured_image_media": {
    "alt_text": "Bedroom with a queen-size bed, dresser, and decorative arrow wall art.",
    "public_id": "019db8df-7c66-724c-bb1b-7a3c92620a3e",
    "storage_key": "property/6767906449166550/019db8df-7c66-724c-bb1b-7a3c92620a3e.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Maximum of two pets allowed (cats and dogs). Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pet rent is $30 per pet per month. Non‑refundable pet fee is half a month’s rent per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://villasofwaterfordapartmentswichita.securecafe.com/onlineleasing/villas-of-waterford-i-ii/floorplans.aspx",
  "property_resident_portal_url": "https://villasofwaterfordapartmentswichita.securecafe.com/residentservices/villas-of-waterford-i-ii/userlogin.aspx",
  "property_apply_now_url": "https://villasofwaterfordapartmentswichita.securecafe.com/onlineleasing/villas-of-waterford-i-ii/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-c0e8-72fc-a0ea-cc501584e7d4.webp",
  "property_primary_logo_media": {
    "alt_text": "The Villas of Waterford logo",
    "public_id": "019cfb4f-c0e8-72fc-a0ea-cc501584e7d4",
    "storage_key": "property/6767906449166550/019cfb4f-c0e8-72fc-a0ea-cc501584e7d4.webp",
    "width": 300,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-3df2-70bf-a870-58fac49e2480.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Villas of Waterford logo.",
    "public_id": "019cfb50-3df2-70bf-a870-58fac49e2480",
    "storage_key": "property/6767906449166550/019cfb50-3df2-70bf-a870-58fac49e2480.webp",
    "width": 300,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-470a-7358-91b9-fa90a685820d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Villas of Waterford logo.",
    "public_id": "019cfb50-470a-7358-91b9-fa90a685820d",
    "storage_key": "property/6767906449166550/019cfb50-470a-7358-91b9-fa90a685820d.webp",
    "width": 300,
    "height": 150
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#62645d",
  "property_secondary_color": "#cabead",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1110",
  "property_sqft_min": "789",
  "property_sqft_max": "1110",
  "property_price_range": "1074 - 1464",
  "property_price_min": "1074",
  "property_price_max": "1464",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/villasofwaterford/photos/d41d8cd9/1477695901027329/",
  "property_instagram_url": "https://www.instagram.com/villasofwaterford/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZb0cCWz9uocR9DO3w05AqMQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Flats&find_loc=Wichita%2C+KS",
  "property_tiktok_url": "https://www.tiktok.com/@villaswaterford",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Villas of Waterford ",
  "property_home_romance_title": "Cherish Every Moment in Your New Apartment Home  ",
  "property_home_amenities_blurb": "Welcome to Villas of Waterford, where comfort meets convenience in Wichita, KS. Choose from spacious one and two-bedroom floor plans, and revel in our resort-style amenities, including two outdoor swimming pools, an onsite fitness center, and a cozy grill & chill area. Experience modern living tailored for you.",
  "property_home_floorplans_blurb": "Welcome to Villas of Waterford in vibrant Wichita, KS, where comfort meets elegance. Our thoughtfully designed one- and two-bedroom apartments offer stunning layouts to suit your lifestyle. Dive into the perfect blend of style and convenience—browse our available homes today and envision your new beginning at Waterford!",
  "property_home_gallery_blurb": "Welcome to Villas of Waterford in Wichita, KS, where vibrant community living meets modern comforts. Choose from spacious one and two-bedroom floor plans, and indulge in amenities like two shimmering pools, a fitness center, and a cozy grill area. Picture a lifestyle filled with convenience, relaxation, and endless possibilities!",
  "property_home_neighborhood_blurb": "Welcome to the Villas of Waterford, where vibrant living meets convenience in Wichita, KS. Choose from charming one or two-bedroom floor plans, and enjoy proximity to attractions like the Museum of World Treasures, Fairmount Park, and Wichita State University. Embrace a lifestyle enriched by both nature and culture!",
  "property_home_reviews_blurb": "At Villas of Waterford in Wichita, KS, our residents appreciate a community where service shines. One resident says, “The maintenance team is always timely and professional.” Join us, and experience the friendly atmosphere and exceptional support that keep our residents smiling. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Villas of Waterford in Wichita, KS, your vibrant lifestyle begins with a wealth of nearby attractions. Embrace culture at the Museum of World Treasures, enjoy events at Charles Koch Arena, or explore the scenic Great Plains Nature Center. The dynamic surrounding community awaits—see what's nearby and elevate your living experience!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Villas of Waterford in Wichita, KS, our charming community invites you to unwind in style. Enjoy two outdoor swimming pools, a vibrant grill & chill area, and a fully equipped fitness center. With pet-friendly options and spacious one and two-bedroom floor plans, your perfect home awaits. Discover unparalleled comfort!",
  "property_applynow_blurb": "At Villas of Waterford in Wichita, KS, luxury meets comfort. Choose from spacious one and two-bedroom floor plans, complete with modern amenities like two outdoor pools, a welcoming clubhouse, and an onsite fitness center. Embrace a pet-friendly lifestyle and seamless online leasing—your inviting retreat awaits!",
  "property_contactus_blurb": "At Villas of Waterford in Wichita, KS, you'll find inviting one and two-bedroom floor plans designed for comfort and style. Each residence offers unique perspectives and ample space, perfect for your lifestyle. Curious about our community? Have questions? Contact our leasing team today and start your journey home!",
  "property_faqs_blurb": "At Villas of Waterford in Wichita, KS, our diverse floor plans cater to every lifestyle. Whether you seek the cozy charm of a one-bedroom or the spacious comfort of a two-bedroom, find the perfect fit for your home. Dive into our FAQs page for insights into our vibrant community!",
  "property_floorplans_blurb": "At Villas of Waterford in Wichita, KS, your ideal living space awaits. Whether you prefer the cozy comfort of a one-bedroom oasis or the spacious charm of a two-bedroom retreat, our diverse floor plans cater to every lifestyle. Browse our available apartment homes and envision your new beginning today!",
  "property_gallery_blurb": "At Villas of Waterford in Wichita, KS, every detail is curated for your comfort. Picture sun-soaked afternoons by one of our two shimmering pools, evenings in the Grill & Chill area, and cozy nights by the fireplace. With stunning floor plans, modern amenities, and a pet-friendly atmosphere, home awaits!",
  "property_interactivemap_blurb": "At Villas of Waterford in Wichita, KS, enjoy the blend of comfort and convenience. Choose from stylish one and two-bedroom floor plans, unwind at two outdoor pools, or stay active at our fitness center. With pet-friendly options and an inviting resident clubhouse, your perfect apartment awaits. Access our interactive community map today!",
  "property_pets_blurb": "At Villas of Waterford in Wichita, KS, your furry companions are valued residents too! Enjoy the freedom of no weight limit for your pets—bring up to two dogs or cats along with you. With thoughtful amenities and a vibrant community, your home is just as inviting for your pets as it is for you.",
  "property_referafriend_blurb": "At Villas of Waterford in Wichita, KS, vibrant living awaits in our thoughtfully designed one and two-bedroom floor plans. Invite your friends to share in the charm of our community—after all, great friends make great neighbors. Refer a friend today and experience elevated living together!",
  "property_residentaccess_blurb": "Welcome to the Villas of Waterford in Wichita, KS, where modern living meets convenience. With spacious one and two-bedroom floor plans, your ideal home awaits. Access your resident portal to easily pay rent, schedule maintenance, and manage your everyday needs seamlessly. Embrace a lifestyle tailored just for you!",
  "property_reviews_blurb": "At Villas of Waterford in Wichita, KS, our residents highlight the exceptional care they receive from our friendly staff. One resident noted, \"They acted quickly!” when issues arise, ensuring comfort and satisfaction. Experience the seamless living our community offers—check out resident reviews to learn more about life at Villas of Waterford!",
  "property_created_at": "1759851541514",
  "property_scheduletour_blurb": "At Villas of Waterford in Wichita, KS, you'll find thoughtfully designed one and two-bedroom apartments that perfectly fit your lifestyle. Schedule a tour today and immerse yourself in a vibrant community where comfort meets convenience. Curious about life here? Our residents can’t wait to share their experiences with you!",
  "property_thankyou_blurb": "Thank you for your interest in Villas of Waterford, where modern living meets comfort in Wichita, KS. Choose from spacious one and two-bedroom floor plans that perfectly fit your lifestyle. Our team will connect with you soon to help you start your journey to exceptional community living!",
  "property_virtualtours_blurb": "Experience the charm of Villas of Waterford in Wichita, KS, where modern elegance meets comfort. Our thoughtfully designed one and two-bedroom apartments offer spacious living for every lifestyle. Dive into a virtual tour of our community and envision your new home today! Your oasis awaits—step inside and see!",
  "property_copyright": "2025 All Rights Reserved. Villas of Waterford ",
  "property_seo_title_home": "Villas of Waterford  |  Apartments in Wichita, KS",
  "property_seo_description_home": "Welcome to Villas of Waterford in Wichita! Enjoy vibrant living with pools, fitness center, clubhouses, and pet-friendly spaces. Your perfect home awaits.",
  "property_seo_title_floorplans": "Floor Plans | Wichita, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Villas of Waterford in Wichita, KS! Choose from stylish one and two-bedroom floor plans that suit your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Wichita, KS Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Villas of Waterford in Wichita, KS! Enjoy two pools, a fitness center, and a cozy clubhouse. Pet-friendly living with stylish floor plans awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, KS",
  "property_seo_description_gallery": "Imagine life at Villas of Waterford in Wichita, KS! Enjoy pools, a fitness center, and cozy spaces. Check out our photo gallery and envision your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Villas of Waterford  Apartments",
  "property_seo_description_virtualtours": "Experience the Villas of Waterford in Wichita, KS! Take a virtual tour of stylish one and two-bedroom apartments and discover your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Villas of Waterford  Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Villas of Waterford in Wichita, KS. Enjoy luxurious amenities, from pools to a playground. Dive into our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, KS",
  "property_seo_description_neighborhood": "Uncover Wichita’s gems near Villas of Waterford! From local favorites to hidden hotspots, your vibrant lifestyle awaits just outside your door.",
  "property_seo_title_contact": "Contact Us | Villas of Waterford ",
  "property_seo_description_contact": "Connect with Villas of Waterford in Wichita, KS! Discover our one and two-bedroom floor plans. Questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, KS",
  "property_seo_description_faqs": "Find answers to your questions about Villas of Waterford in Wichita, KS. Learn about amenities, floor plans, and life in our pet-friendly community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, KS",
  "property_seo_description_reviews": "At Villas of Waterford in Wichita, KS, our residents enjoy luxury amenities, two pools, and a vibrant community. See what they love about calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, KS",
  "property_seo_description_applynow": "Welcome to Villas of Waterford in Wichita, KS! Enjoy our pet-friendly community with two pools, a fitness center, and a cozy clubhouse. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Villas of Waterford ",
  "property_seo_description_residentaccess": "Log in to the Villas of Waterford resident portal in Wichita, KS. Manage rent, request maintenance, and enjoy seamless living at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Villas of Waterford ",
  "property_seo_description_referafriend": "Refer a friend to Villas of Waterford in Wichita, KS! Enjoy a welcoming community where great friendships flourish. Live beautifully together today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Villas of Waterford ",
  "property_seo_description_scheduletour": "Experience the charm of Villas of Waterford in Wichita, KS. Book your tour now and envision your future in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Villas of Waterford ",
  "property_seo_description_privacy": "Your privacy matters at Villas of Waterford in Wichita, KS. Dive into our privacy policy to see how we protect your personal information securely.",
  "property_seo_title_accessibility": "Website Accessibility | Villas of Waterford ",
  "property_seo_description_accessibility": "At Villas of Waterford, Wichita, KS, we prioritize accessibility and inclusivity for all. Join us in fostering a welcoming community!",
  "property_seo_title_sitemap": "Sitemap | Villas of Waterford ",
  "property_seo_description_sitemap": "Unlock the layout of your next home at Villas of Waterford! Browse our sitemap to find the perfect apartment in vibrant Wichita, KS. Your adventure awaits!",
  "property_seo_title_thankyou": "Thank You | Villas of Waterford ",
  "property_seo_description_thankyou": "Thank you for contacting us! Your vibrant journey at Villas of Waterford in Wichita, KS is starting. Expect a quick reply from our team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866112211",
  "amenities": [
    {
      "id": "ec_669f42cc91d8b9e7fa759276",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397428",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eea45fa8186b0c346d42e26d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397429",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0fe9f65140142fb0fa28b8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397432",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d0cff3b9610fd571c7985b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397433",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8460a5430448771bacde4397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397434",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfd4c4a40fe5b34a7b8cbf4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397435",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2378c65d93c920cb4d5dd80f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397437",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99fe71a9b34be629df10c356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397438",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cffee86d6562effd36cb6901",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397439",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3b15086a5fbff4d3ae6f413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397440",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c11902228f84a5d51ff85f06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "128042563",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee2d986b1e31ad24638a9cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127397441",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cc84704d904ef2abe81bcff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "128017306",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_614cc0725f0dbbe7957ba470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398884",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1d18089e83497a0288b4c7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398885",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f89f159a12369111e1728705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398886",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b82d8f9813473b17efb1849",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398887",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68e70a3c18fd300f842549a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398888",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ce6a4c3b63e28be3385bfb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398889",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61a4b530f5e085e02b675932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398890",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ab173850611920ed2a346d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398891",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70bdf29321725d7b36296957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398892",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7a777c57b8f3a7bc22437da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398893",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbfab21a98642c653ebceb0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398894",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15836eea7e8c64861a14b35a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398895",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d0faf7f86a09b1cb95f6c05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398896",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6db85d6c5c075aecc7e70220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398897",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6b5db6af75f6e2b40c41f61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398898",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_425763243e5378bd7a6b9b40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "yardi",
      "external_id": "127398899",
      "title": "Upgraded Interiors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9097c25e-431a-4590-9f9d-ea5922829971",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5d0-d57d-769b-9704-6038e3d54f39.webp",
      "image_media": {
        "alt_text": "Double doors with windows in an entryway with a chandelier above.",
        "public_id": "019db5d0-d57d-769b-9704-6038e3d54f39",
        "storage_key": "property/6767906449166550/019db5d0-d57d-769b-9704-6038e3d54f39.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Welcome guests into the property through elegant double doors, featuring a stylish chandelier and a comfortable seating area.",
      "link": "",
      "alt_text": "Double doors with windows in an entryway with a chandelier above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e90fc6f-04cf-4b0b-b9fc-0c4c62b36c2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5d0-d63d-741c-909b-669cbde62650.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with fireplace, seating, and view of the pool.",
        "public_id": "019db5d0-d63d-741c-909b-669cbde62650",
        "storage_key": "property/6767906449166550/019db5d0-d63d-741c-909b-669cbde62650.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a modern fireplace, comfortable seating, and stunning views of the resort-style pool.",
      "link": "",
      "alt_text": "Spacious lounge area with fireplace, seating, and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_98b9d4a2-91ca-4f3d-81ba-f541416e7187",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5d0-9bdb-7309-b498-18cde806ada1.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, stationary bikes, free weights, and medicine balls.",
        "public_id": "019db5d0-9bdb-7309-b498-18cde806ada1",
        "storage_key": "property/6767906449166550/019db5d0-9bdb-7309-b498-18cde806ada1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a wide array of cardio machines, weight equipment, and free weights to help you achieve your fitness goals.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, stationary bikes, free weights, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a27a7df7-fb28-477f-b0f6-6f55c03ddd79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5d0-3caf-717e-94f3-198f0f49e587.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, stationary bikes, and elliptical machines, featuring TVs on the wall.",
        "public_id": "019db5d0-3caf-717e-94f3-198f0f49e587",
        "storage_key": "property/6767906449166550/019db5d0-3caf-717e-94f3-198f0f49e587.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio machines and free weights.",
      "link": "",
      "alt_text": "Gym with treadmills, stationary bikes, and elliptical machines, featuring TVs on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1376863a-32f4-4238-88fc-23440e3a9f8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-c3ca-7151-82dd-45336a6c1bb5.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, vanity, and shower",
        "public_id": "019db5cf-c3ca-7151-82dd-45336a6c1bb5",
        "storage_key": "property/6767906449166550/019db5cf-c3ca-7151-82dd-45336a6c1bb5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a clean white toilet, a spacious vanity with a sink and ample storage, and a shower with a stylish curtain. This apartment bathroom offers both functionality and contemporary design.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, vanity, and shower",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_628c493c-224e-4dcf-8106-fce738416267",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-b384-7654-b21a-a5de3ca94ff8.webp",
      "image_media": {
        "alt_text": "A stylish bedroom featuring a plush gray headboard, deep purple bedding with a mustard yellow throw, and modern art above the bed.",
        "public_id": "019db5cf-b384-7654-b21a-a5de3ca94ff8",
        "storage_key": "property/6767906449166550/019db5cf-b384-7654-b21a-a5de3ca94ff8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in comfort in this elegantly appointed bedroom, designed for ultimate relaxation and style. Features a spacious closet and ample natural light.",
      "link": "",
      "alt_text": "A stylish bedroom featuring a plush gray headboard, deep purple bedding with a mustard yellow throw, and modern art above the bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2fbeb95a-f3b0-4a5f-8d7b-1630fbbe5b64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-b154-763f-af26-ffc256f2ed88.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and artwork.",
        "public_id": "019db5cf-b154-763f-af26-ffc256f2ed88",
        "storage_key": "property/6767906449166550/019db5cf-b154-763f-af26-ffc256f2ed88.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable bed, a stylish dresser, and modern wall art, creating a serene living space.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd6736a1-fc98-4f9a-81bc-7cbf45fb5cab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-a867-72cf-98e0-a91d1bda93e8.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and a hallway with dog bed and bowls.",
        "public_id": "019db5cf-a867-72cf-98e0-a91d1bda93e8",
        "storage_key": "property/6767906449166550/019db5cf-a867-72cf-98e0-a91d1bda93e8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A bright bathroom features a vanity with a sink and a mirror. A nearby hallway is equipped for pets with a bed and food bowls.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and a hallway with dog bed and bowls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74cbcd18-a63f-4c9e-9ffd-9bd533ab8fc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-9efe-76f8-9e68-4465f8514036.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
        "public_id": "019db5cf-9efe-76f8-9e68-4465f8514036",
        "storage_key": "property/6767906449166550/019db5cf-9efe-76f8-9e68-4465f8514036.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring warm wooden cabinets, a white oven and microwave, and durable granite countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce17715e-2262-4bac-baa6-28d7c74735dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-9efb-700b-ae52-fecff281cd65.webp",
      "image_media": {
        "alt_text": "Dining table with chairs in a sunlit living room.",
        "public_id": "019db5cf-9efb-700b-ae52-fecff281cd65",
        "storage_key": "property/6767906449166550/019db5cf-9efb-700b-ae52-fecff281cd65.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals and gatherings in this spacious dining area, seamlessly connected to the living room, featuring a stylish dining table and chairs.",
      "link": "",
      "alt_text": "Dining table with chairs in a sunlit living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4d0b228-f718-45ee-8eaf-d265f4e4505b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-9d52-7196-ad85-c612def02e1a.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
        "public_id": "019db5cf-9d52-7196-ad85-c612def02e1a",
        "storage_key": "property/6767906449166550/019db5cf-9d52-7196-ad85-c612def02e1a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and vanity with sink, perfect for your daily routines.",
      "link": "",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4661d0a1-c00b-41ef-b451-226e9b7ce052",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-9129-74e0-b1ca-48a33f33e216.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, and a breakfast bar with stools.",
        "public_id": "019db5cf-9129-74e0-b1ca-48a33f33e216",
        "storage_key": "property/6767906449166550/019db5cf-9129-74e0-b1ca-48a33f33e216.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, granite countertops, and a convenient breakfast bar with stylish stools. Perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, and a breakfast bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f2679b2-5b2a-41f2-94eb-c09ab90c9d5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-999b-71fc-b9f0-7efb9d46af15.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, vanity, and shower curtain.",
        "public_id": "019db5cf-999b-71fc-b9f0-7efb9d46af15",
        "storage_key": "property/6767906449166550/019db5cf-999b-71fc-b9f0-7efb9d46af15.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Explore this apartment's functional and tidy bathroom, featuring a toilet, a wooden vanity with a sink, and a shower curtain.",
      "link": "",
      "alt_text": "Bathroom with a toilet, vanity, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef09def4-ff81-47dd-85e2-ad277ec9c9b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-8f3e-73a5-b9a4-f2603447ee6f.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, next to a sliding glass door with a balcony view.",
        "public_id": "019db5cf-8f3e-73a5-b9a4-f2603447ee6f",
        "storage_key": "property/6767906449166550/019db5cf-8f3e-73a5-b9a4-f2603447ee6f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area, perfect for intimate gatherings or everyday dining. The space flows seamlessly to a private balcony.",
      "link": "",
      "alt_text": "Dining area with table and chairs, next to a sliding glass door with a balcony view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80a92bf5-5dcf-4cd0-9419-2cff99b32300",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-8066-723e-94ce-cd32ad73d8d1.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen with a sofa, armchair, coffee table, dining area, and kitchen island with bar stools.",
        "public_id": "019db5cf-8066-723e-94ce-cd32ad73d8d1",
        "storage_key": "property/6767906449166550/019db5cf-8066-723e-94ce-cd32ad73d8d1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sofa, stylish armchair, and a modern coffee table, flowing into a dining space and a fully equipped kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen with a sofa, armchair, coffee table, dining area, and kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da0d4364-bcec-4e91-8497-4a8443d4b127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-6d49-7456-856e-749d7b3914f6.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "019db5cf-6d49-7456-856e-749d7b3914f6",
        "storage_key": "property/6767906449166550/019db5cf-6d49-7456-856e-749d7b3914f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush queen-size bed, a stylish nightstand with a lamp, and a spacious dresser for all your storage needs.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2b6421b-7252-4686-be8e-022480aa3ac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-6cfa-751a-b721-8f145457325f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019db5cf-6cfa-751a-b721-8f145457325f",
        "storage_key": "property/6767906449166550/019db5cf-6cfa-751a-b721-8f145457325f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a vanity, toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8fc8f027-4070-4351-b39b-eca65423c117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-7549-7639-a7e8-550fbeb7cc34.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sliding glass door leading to a patio.",
        "public_id": "019db5cf-7549-7639-a7e8-550fbeb7cc34",
        "storage_key": "property/6767906449166550/019db5cf-7549-7639-a7e8-550fbeb7cc34.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with abundant natural light and access to outdoor space.",
      "link": "",
      "alt_text": "Living and dining area with a sliding glass door leading to a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b30b397-cdf7-4af1-91f7-7ddacfd8b2c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-7056-742b-9fb2-19024fb058d8.webp",
      "image_media": {
        "alt_text": "View of apartment buildings from a balcony or patio.",
        "public_id": "019db5cf-7056-742b-9fb2-19024fb058d8",
        "storage_key": "property/6767906449166550/019db5cf-7056-742b-9fb2-19024fb058d8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors from your private balcony or patio, with a view of the community's charming apartment buildings.",
      "link": "",
      "alt_text": "View of apartment buildings from a balcony or patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96a2c0cd-d841-4315-8f6b-7696a0c7df5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-4b55-74a7-872b-dc529a84ca63.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, including tunnels and ramps, adjacent to apartment buildings.",
        "public_id": "019db5cf-4b55-74a7-872b-dc529a84ca63",
        "storage_key": "property/6767906449166550/019db5cf-4b55-74a7-872b-dc529a84ca63.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community dog park, complete with agility equipment for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park with agility equipment, including tunnels and ramps, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d808d6f-dccf-49ee-bd40-ebe6b08ebe42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-36f6-72eb-9b61-10f0f82c0984.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, and TV stand.",
        "public_id": "019db5cf-36f6-72eb-9b61-10f0f82c0984",
        "storage_key": "property/6767906449166550/019db5cf-36f6-72eb-9b61-10f0f82c0984.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, a stylish armchair, and a modern TV stand, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54990635-8c4e-4ab6-ad45-1d2a3f95a8bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-58e6-7051-8dd6-7f9e9aee26d2.webp",
      "image_media": {
        "alt_text": "Interior view of a bathroom with a vanity, sink, and mirror, leading to a laundry area with washers and dryers.",
        "public_id": "019db5cf-58e6-7051-8dd6-7f9e9aee26d2",
        "storage_key": "property/6767906449166550/019db5cf-58e6-7051-8dd6-7f9e9aee26d2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of in-unit laundry with washer and dryer hookups, adjacent to a well-appointed bathroom.",
      "link": "",
      "alt_text": "Interior view of a bathroom with a vanity, sink, and mirror, leading to a laundry area with washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9e209a3-b7ae-4ad3-90df-59dedf485277",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-5490-76f9-97d8-daa2834c4135.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and wooden cabinets. Includes toilet and bathtub with shower curtain.",
        "public_id": "019db5cf-5490-76f9-97d8-daa2834c4135",
        "storage_key": "property/6767906449166550/019db5cf-5490-76f9-97d8-daa2834c4135.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a vanity with ample counter space, a sink, and storage cabinets. Enjoy a relaxing soak in the bathtub or a quick shower.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and wooden cabinets. Includes toilet and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_766e6472-ebcf-442a-8258-4a4876c4c1c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-36f4-73fd-83e8-e6688526e7bb.webp",
      "image_media": {
        "alt_text": "Living room with a couch, armchair, and TV.",
        "public_id": "019db5cf-36f4-73fd-83e8-e6688526e7bb",
        "storage_key": "property/6767906449166550/019db5cf-36f4-73fd-83e8-e6688526e7bb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional couch, armchair, and a modern entertainment center with a flat-screen TV. Large windows fill the room with natural light.",
      "link": "",
      "alt_text": "Living room with a couch, armchair, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69367bb7-bb75-47e2-b31a-9ee6b9055041",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-3507-75ec-9483-ec0d632f691e.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white stove and microwave, and granite countertops.",
        "public_id": "019db5cf-3507-75ec-9483-ec0d632f691e",
        "storage_key": "property/6767906449166550/019db5cf-3507-75ec-9483-ec0d632f691e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring warm wood cabinetry, a white range with a built-in microwave above, and speckled granite countertops. A white sink and a window add to the bright and inviting atmosphere.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white stove and microwave, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d630093-eac5-42b8-9b67-2902e3d9d51d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-350b-7051-9142-c21a6c0b44a9.webp",
      "image_media": {
        "alt_text": "Kitchen area with island and bar stools.",
        "public_id": "019db5cf-350b-7051-9142-c21a6c0b44a9",
        "storage_key": "property/6767906449166550/019db5cf-350b-7051-9142-c21a6c0b44a9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen area featuring an island with bar stools, granite countertops, and wooden cabinetry. Perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Kitchen area with island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b48c78ef-d6eb-4b21-81fc-d1aa90708390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-3501-774f-b574-3a71e866b50b.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a large abstract painting on the wall.",
        "public_id": "019db5cf-3501-774f-b574-3a71e866b50b",
        "storage_key": "property/6767906449166550/019db5cf-3501-774f-b574-3a71e866b50b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, complete with a stylish round table, comfortable seating, and elegant wall art.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a large abstract painting on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_433c4880-e6c6-46e7-a134-d30e16fe71a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-3363-75d9-a340-19f70cf93fd7.webp",
      "image_media": {
        "alt_text": "Spacious living room with a curved sofa, ottoman, and dining area.",
        "public_id": "019db5cf-3363-75d9-a340-19f70cf93fd7",
        "storage_key": "property/6767906449166550/019db5cf-3363-75d9-a340-19f70cf93fd7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy abundant natural light and elegant design in this open-concept living and dining space, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Spacious living room with a curved sofa, ottoman, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a77a3d1-0178-4cb4-b841-d95ef36e2eb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-34db-716c-a587-9c823db18e73.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking apartment buildings and a courtyard with a pool.",
        "public_id": "019db5cf-34db-716c-a587-9c823db18e73",
        "storage_key": "property/6767906449166550/019db5cf-34db-716c-a587-9c823db18e73.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy scenic views of the community grounds and apartment buildings from your private balcony.",
      "link": "",
      "alt_text": "View from a balcony overlooking apartment buildings and a courtyard with a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a630cd60-674c-43f4-825d-478991709081",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-e28d-775e-9845-4540e569a9d4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db5ce-e28d-775e-9845-4540e569a9d4",
        "storage_key": "property/6767906449166550/019db5ce-e28d-775e-9845-4540e569a9d4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Enjoy the beautiful weather and resort-style amenities.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51549ec2-3c18-41cb-9c3c-77294ec5574c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-d181-7369-8396-28dc2e9937a5.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a building in the background.",
        "public_id": "019db5ce-d181-7369-8396-28dc2e9937a5",
        "storage_key": "property/6767906449166550/019db5ce-d181-7369-8396-28dc2e9937a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd7a8f5f-4398-41ba-873e-740c5f97e282",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-b7b0-728d-b649-1cf155c9a283.webp",
      "image_media": {
        "alt_text": "Apartment building exteriors with a walkway and green lawn.",
        "public_id": "019db5ce-b7b0-728d-b649-1cf155c9a283",
        "storage_key": "property/6767906449166550/019db5ce-b7b0-728d-b649-1cf155c9a283.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with manicured lawns and a paved walkway leading towards modern apartment buildings under a clear blue sky.",
      "link": "",
      "alt_text": "Apartment building exteriors with a walkway and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2fbb3c76-08b4-4360-9586-fbb061820813",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-d667-73bf-927f-42363b716f1e.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and trees under a blue sky with clouds.",
        "public_id": "019db5ce-d667-73bf-927f-42363b716f1e",
        "storage_key": "property/6767906449166550/019db5ce-d667-73bf-927f-42363b716f1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lounge chairs and lush greenery. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and trees under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8326fe3a-128e-4a11-b092-7d1c82a3b366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-d1c7-74d6-9e4a-0d77b7e56e94.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db5ce-d1c7-74d6-9e4a-0d77b7e56e94",
        "storage_key": "property/6767906449166550/019db5ce-d1c7-74d6-9e4a-0d77b7e56e94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca178f92-ceed-47bc-ba4b-e65d01c782b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-b66b-76ed-ab6f-3d053080de8c.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building entrance and grounds.",
        "public_id": "019db5ce-b66b-76ed-ab6f-3d053080de8c",
        "storage_key": "property/6767906449166550/019db5ce-b66b-76ed-ab6f-3d053080de8c.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Welcome to your new home! This exterior shot showcases the beautiful architecture and landscaping of our community.",
      "link": "",
      "alt_text": "Exterior view of the apartment building entrance and grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1734d39c-9f71-412c-aa4e-338673012fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-b6d0-728d-a905-acec01ee4c18.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019db5ce-b6d0-728d-a905-acec01ee4c18",
        "storage_key": "property/6767906449166550/019db5ce-b6d0-728d-a905-acec01ee4c18.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring private balconies and lush green spaces, creating a serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df88837d-7432-42ab-9a6e-d01b43bf4b8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-b727-77c9-9cb6-e91a19da675d.webp",
      "image_media": {
        "alt_text": "Apartment building with attached garages and a parking lot with cars.",
        "public_id": "019db5ce-b727-77c9-9cb6-e91a19da675d",
        "storage_key": "property/6767906449166550/019db5ce-b727-77c9-9cb6-e91a19da675d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing attached garages and a well-maintained parking area with vehicles.",
      "link": "",
      "alt_text": "Apartment building with attached garages and a parking lot with cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b292aeea-0860-49e9-9d51-cc5da27a96ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-9e9b-705f-9f0d-303d9fc93b86.webp",
      "image_media": {
        "alt_text": "Brick building entrance with a large 'W' logo above arched doorway, surrounded by landscaping.",
        "public_id": "019db5ce-9e9b-705f-9f0d-303d9fc93b86",
        "storage_key": "property/6767906449166550/019db5ce-9e9b-705f-9f0d-303d9fc93b86.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community! This photo shows the main building entrance, featuring classic brick architecture and lush landscaping, creating an inviting first impression.",
      "link": "",
      "alt_text": "Brick building entrance with a large 'W' logo above arched doorway, surrounded by landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bdefec9b-3b6f-4575-ada0-6f1d9a820a02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-a013-7468-ac25-970d77dbb62e.webp",
      "image_media": {
        "alt_text": "The Villas of Waterford monument sign with a black SUV driving by.",
        "public_id": "019db5ce-a013-7468-ac25-970d77dbb62e",
        "storage_key": "property/6767906449166550/019db5ce-a013-7468-ac25-970d77dbb62e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to The Villas of Waterford, a beautiful apartment community. Our monument sign is the first impression of our lovely property.",
      "link": "",
      "alt_text": "The Villas of Waterford monument sign with a black SUV driving by.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e2b0bb5-7119-4657-b097-d22f68ceba9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-a071-707b-8aa6-799651255ee9.webp",
      "image_media": {
        "alt_text": "Outdoor community grilling area with picnic tables, grills, and a stone fireplace.",
        "public_id": "019db5ce-a071-707b-8aa6-799651255ee9",
        "storage_key": "property/6767906449166550/019db5ce-a071-707b-8aa6-799651255ee9.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in our community grilling area, featuring comfortable seating, convenient grills, and a cozy stone fireplace perfect for evening relaxation.",
      "link": "",
      "alt_text": "Outdoor community grilling area with picnic tables, grills, and a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7f2d26e6-8291-44d6-8376-c3f32eb6e316",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2526 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and fried pickles, and the rolls are a highlight. They highlight the fair prices and fun, casual atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-139b-765d-b89c-19ac53ccd96d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-139b-765d-b89c-19ac53ccd96d",
        "storage_key": "property/6767906449166550/019cfb50-139b-765d-b89c-19ac53ccd96d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-n-greenwich-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=1637772610376225648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.7278459",
      "poi_longitude": "-97.2071071",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-634-1106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_-1abr9uocRcNNWCIOJuhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4fb5caf7-ead8-4a55-b5fc-1dbfa608a510",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Topgolf Wichita",
      "poi_type": "Restaurants",
      "poi_address": "2976 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun games and a variety of food and drinks. They also highlight the upbeat atmosphere and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-14d7-711d-badd-24390072c265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-14d7-711d-badd-24390072c265",
        "storage_key": "property/6767906449166550/019cfb50-14d7-711d-badd-24390072c265.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3659202844621293977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-wichita",
      "poi_latitude": "37.7368549",
      "poi_longitude": "-97.2071488",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-394-4065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUU5Coj9uocRmUnAkpkZyDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1ef1aea2-0f58-45d8-a3ad-3ec81fb35bc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "1240 N Greenwich Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Family-friendly, game joint known for rotisserie chicken, pickleball courts and yard games.",
      "poi_long_description": "People say this restaurant offers a variety of fun outdoor games, pickleball courts, and a spacious indoor area with TVs and a bar. They also highlight the fun and energetic atmosphere, and the friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e483-705a-828a-b2e3b8cd7a39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e483-705a-828a-b2e3b8cd7a39",
        "storage_key": "property/6767906449166550/019cfb4f-e483-705a-828a-b2e3b8cd7a39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640495953640467354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---wichita",
      "poi_latitude": "37.70694599999999",
      "poi_longitude": "-97.205714",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-535-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZsOYJL9uocRmqv8GsijhTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4a493d90-656d-4b25-b4ff-573835117f13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2400 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches and waffle fries. They also highlight the quick service and friendly staff.\n\nOther reviews mention the drive-thru can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e2e9-708e-bf62-715469ea2a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e2e9-708e-bf62-715469ea2a3d",
        "storage_key": "property/6767906449166550/019cfb4f-e2e9-708e-bf62-715469ea2a3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/k96-greenwich-rd-ks?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4809767043547304648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.726752",
      "poi_longitude": "-97.207335",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-369-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJre8SHCP9uocRyJIEk6S5v0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e8fb26be-3277-4162-a581-872685c6c990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Towne East Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Big mall with a classic range of department stores, specialty boutiques & kiosks, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide selection of clothes, shoes, and sporting goods, and has a good food court. They also highlight the clean and safe environment, and the fun atmosphere.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e2e0-7716-beea-a8c2fce70199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e2e0-7716-beea-a8c2fce70199",
        "storage_key": "property/6767906449166550/019cfb4f-e2e0-7716-beea-a8c2fce70199.webp",
        "width": 550,
        "height": 366
      },
      "poi_business_url": "https://www.simon.com/mall/towne-east-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=15194517817475507784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "towne-east-square",
      "poi_latitude": "37.6832262",
      "poi_longitude": "-97.2469947",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-686-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-4dfd8edcb7c2",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZfKSnrz8uocRSKb4c3PF3dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_353754c0-fe51-44da-9c27-073590a33d37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1423 N Webb Rd Ste 101, Wichita, KS 67206, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, organic produce, meat, and prepackaged goods, as well as a bakery, prepared foods, and a coffee shop. They also highlight the clean, organized layout, the friendly and helpful staff, and the convenient Amazon returns.\n\nOther reviews mention the store can be understocked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-14a8-7381-8cff-ec35d4b616c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-14a8-7381-8cff-ec35d4b616c6",
        "storage_key": "property/6767906449166550/019cfb50-14a8-7381-8cff-ec35d4b616c6.webp",
        "width": 1280,
        "height": 934
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/wichita?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11170048129198724117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "37.7089215",
      "poi_longitude": "-97.227764",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-630-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe14-76eb-99e7-de9b204878ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe14-76eb-99e7-de9b204878ef",
        "storage_key": "property/6767906449166550/019cfb4f-fe14-76eb-99e7-de9b204878ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVf9R_n8uocRFRTokJf7A5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c33458a6-ad09-4ab1-958d-be5196c9eac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 N Rock Rd Ste 120, Wichita, KS 67206, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, unique snacks, and beautiful flowers. They highlight the affordable prices and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e4a9-76fb-a6a5-ebc04ad0177a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e4a9-76fb-a6a5-ebc04ad0177a",
        "storage_key": "property/6767906449166550/019cfb4f-e4a9-76fb-a6a5-ebc04ad0177a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/ks/wichita/729/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564502814785791359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "37.7163031",
      "poi_longitude": "-97.2434865",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-634-1846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe14-76eb-99e7-de9b204878ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe14-76eb-99e7-de9b204878ef",
        "storage_key": "property/6767906449166550/019cfb4f-fe14-76eb-99e7-de9b204878ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaX4mJJL9uocRf-XfhNg4ANg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_27f28384-359c-4060-ac7b-07368fcdc51a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3350 N Woodlawn St, Wichita, KS 67220, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of home items, including paint, and has helpful and friendly staff. They also highlight the competitive prices and good sales.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-13ad-7398-8d4e-710a01e8a197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-13ad-7398-8d4e-710a01e8a197",
        "storage_key": "property/6767906449166550/019cfb50-13ad-7398-8d4e-710a01e8a197.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/East-Wichita/KS/Wichita/67220/2204?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636944138880415122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.7443293",
      "poi_longitude": "-97.2612274",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-681-0899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-4dfd8edcb7c2",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf_RUnE39uocRkvWjXVYEnpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0a6ffc16-951b-45c0-aa71-aed817ffd291",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3250 N Toben St, Wichita, KS 67226, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products at reasonable prices, including construction supplies, and is a great place for DIY projects. They also highlight the helpful staff and convenient pick-up option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e438-72b1-af7f-45e1f516dd3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e438-72b1-af7f-45e1f516dd3c",
        "storage_key": "property/6767906449166550/019cfb4f-e438-72b1-af7f-45e1f516dd3c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3275&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6112294342705808708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.743853",
      "poi_longitude": "-97.230225",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-630-8307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-4dfd8edcb7c2",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB4oMUXD9uocRRAWcA1I701Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_63646de5-7c05-4f23-9fbc-57081faeb554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e2f3-7271-8949-3da427138b12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e2f3-7271-8949-3da427138b12",
        "storage_key": "property/6767906449166550/019cfb4f-e2f3-7271-8949-3da427138b12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b4e0ec76-be33-4720-ad64-09a1f657047e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "WSU Tech | National Center for Aviation Training (NCAT)",
      "poi_type": "Education",
      "poi_address": "4004 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-15c4-76ed-b9d6-52a6272ac51a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-15c4-76ed-b9d6-52a6272ac51a",
        "storage_key": "property/6767906449166550/019cfb50-15c4-76ed-b9d6-52a6272ac51a.webp",
        "width": 639,
        "height": 359
      },
      "poi_business_url": "https://wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12806940655175411833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsu-tech--national-center-for-aviation-training-ncat",
      "poi_latitude": "37.756972",
      "poi_longitude": "-97.2242927",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA-DVNYACu4cReSg9-6tku7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e2f6ddf7-89ee-4b00-9b79-776bc6409132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Woolsey Hall",
      "poi_type": "Education",
      "poi_address": "Student Wellness Center Steve Clark YMCA 2060 N Mid-Campus Drive, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-15c8-76dc-a471-c3ffd4c6a3ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-15c8-76dc-a471-c3ffd4c6a3ed",
        "storage_key": "property/6767906449166550/019cfb50-15c8-76dc-a471-c3ffd4c6a3ed.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.wichita.edu/academics/business/woolsey_hall_2022.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=8990881046444541568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woolsey-hall",
      "poi_latitude": "37.7186727",
      "poi_longitude": "-97.2882013",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-978-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-e46vvTjuocRgIYeD60Gxnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_388a88b9-3231-4b5a-92ec-6254247404c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Charles Koch Arena",
      "poi_type": "Entertainment",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "Huge sporting venue inside Koch Arena hosting basketball games, as well as graduations.",
      "poi_long_description": "People say this arena is a great venue for graduations, sporting events, and concerts. They highlight the easy access, organized entry, and helpful staff. They also like the spacious seating, good views, and large TVs that allow for close-up views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1677-70fd-a559-b521e350f2e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1677-70fd-a559-b521e350f2e9",
        "storage_key": "property/6767906449166550/019cfb50-1677-70fd-a559-b521e350f2e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goshockers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14669727161295634234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charles-koch-arena",
      "poi_latitude": "37.7218564",
      "poi_longitude": "-97.2973448",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-978-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q884-_iuocROv_sMCFXlcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ecc355d8-fb5f-4779-b987-d47f906e4b6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Museum of World Treasures",
      "poi_type": "Entertainment",
      "poi_address": "835 E 1st St N, Wichita, KS 67202, USA",
      "poi_short_description": "A history-of-the-world museum with an educational focus & hands-on children's activity center.",
      "poi_long_description": "People say this museum offers a diverse collection of artifacts from around the world and across many different time periods, including dinosaurs, mummies, and items from the Western era. They highlight the museum is packed with excellent exhibits and provides a good experience for families. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-e6f5-7511-9c4b-13bbd2883664.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-e6f5-7511-9c4b-13bbd2883664",
        "storage_key": "property/6767906449166550/019cfb4f-e6f5-7511-9c4b-13bbd2883664.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "http://worldtreasures.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1404316722265454010&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-world-treasures",
      "poi_latitude": "37.687089",
      "poi_longitude": "-97.327885",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe20-77b6-a94c-0de6aa2f8b58",
        "storage_key": "property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdz_xfJXjuocRuvXFVp4ifRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_27d68dfb-b05c-4638-8744-050962547a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Cessna Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1845 E 21st St N, Wichita, KS 67260, USA",
      "poi_short_description": "Stadium used for track meets and other sports events with bleachers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1704-751b-ab93-a7b3e41ad04d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1704-751b-ab93-a7b3e41ad04d",
        "storage_key": "property/6767906449166550/019cfb50-1704-751b-ab93-a7b3e41ad04d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://goshockers.com/sports/2015/5/26/Cessna_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1895230992599072842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cessna-stadium",
      "poi_latitude": "37.7217064",
      "poi_longitude": "-97.2955332",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-978-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-489c1a266d93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-489c1a266d93",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-489c1a266d93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwFEhe_iuocRSsAt4Ys2TRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_fcdb4916-a5f5-44d8-9c31-5e2369c994e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Frank Lloyd Wright's Allen House",
      "poi_type": "Entertainment",
      "poi_address": "255 N Roosevelt St, Wichita, KS 67208, USA",
      "poi_short_description": "Guided tours through the period interiors of a 1918 Prairie-style home by Frank Lloyd Wright.",
      "poi_long_description": "People say this museum offers an amazing presentation of architecture and a fascinating guided tour. They highlight the historical significance of the house and the knowledgeable docents. They also like the friendly and entertaining tour guides. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1738-7168-b464-b3607c053e2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1738-7168-b464-b3607c053e2a",
        "storage_key": "property/6767906449166550/019cfb50-1738-7168-b464-b3607c053e2a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://flwrightwichita.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14152560708377734465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frank-lloyd-wrights-allen-house",
      "poi_latitude": "37.6897888",
      "poi_longitude": "-97.2924084",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-687-1027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe20-77b6-a94c-0de6aa2f8b58",
        "storage_key": "property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmx3qVRPjuocRQW0BFfv-Z8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_db2d6324-bb88-4989-8e70-63fd97878e3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Eck Stadium - Tyler Field",
      "poi_type": "Entertainment",
      "poi_address": "4100 E 21st St N, Wichita, KS 67208, USA",
      "poi_short_description": "Cozy venue with outfield benches and other seating for college baseball games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-17ce-7015-a914-e5b4ac2458ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-17ce-7015-a914-e5b4ac2458ff",
        "storage_key": "property/6767906449166550/019cfb50-17ce-7015-a914-e5b4ac2458ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://goshockers.com/sports/2015/5/26/Eck_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16739415824998152798&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eck-stadium---tyler-field",
      "poi_latitude": "37.721554",
      "poi_longitude": "-97.2889522",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-978-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-489c1a266d93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-489c1a266d93",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-489c1a266d93.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFcCoDOjiuocRXjqR7ABaTug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b110de14-14ec-41a4-bcd5-c14fcab049df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3535 N Rock Rd Ste 200, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of well-maintained equipment and is rarely crowded. They also highlight the affordable membership options, the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the air conditioning can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-17f1-70f4-af67-6ef773d62a4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-17f1-70f4-af67-6ef773d62a4a",
        "storage_key": "property/6767906449166550/019cfb50-17f1-70f4-af67-6ef773d62a4a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-n-rock-rd-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4859550944777095639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.7472922",
      "poi_longitude": "-97.2476434",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-831-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWiF9Fz9uocR10laV9aXcEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_766d564c-1357-40b6-ac90-cb7fac2ceab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Rock Road",
      "poi_type": "Health and Wellness",
      "poi_address": "1551 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "State-of-the-art fitness center chain outlet in Wichita, Kansas, offering a variety of workout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-ea6e-71e7-a4b8-baacf3c92093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-ea6e-71e7-a4b8-baacf3c92093",
        "storage_key": "property/6767906449166550/019cfb4f-ea6e-71e7-a4b8-baacf3c92093.webp",
        "width": 862,
        "height": 485
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/rock-road.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14856835678487964422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---rock-road",
      "poi_latitude": "37.7117118",
      "poi_longitude": "-97.245851",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-634-0094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdkopd_8uocRBuufrlUVLs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dcb42dc6-bd5f-4c41-9d82-60ba85bdb2bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Harry",
      "poi_type": "Health and Wellness",
      "poi_address": "1607 S Georgetown St, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious fitness center with a swimming pool and a sauna that focuses on helping members reach their goals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-ec0b-765e-95ec-f36fd4803641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-ec0b-765e-95ec-f36fd4803641",
        "storage_key": "property/6767906449166550/019cfb4f-ec0b-765e-95ec-f36fd4803641.webp",
        "width": 715,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-harry.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8289705737227987081&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-harry",
      "poi_latitude": "37.6632431",
      "poi_longitude": "-97.2865009",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-768-8121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6YqvsfluocRiej9f3LzCnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b3394b9f-9d88-47e5-9919-082e3c54a903",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Central",
      "poi_type": "Health and Wellness",
      "poi_address": "6100 E Central Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Gym, yoga spot, and fitness center featuring cardio equipment, weight machines and free weights, plus 1-on-1 training.",
      "poi_long_description": "People say this gym offers a wide variety of new and updated equipment, as well as recovery amenities like hydro chairs, a sauna, and a jacuzzi. They also highlight the friendly, helpful, and supportive staff, and the unique, retro vibe with neon lighting.\n\nOther reviews mention the gym can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1972-740d-b682-55a4bcfa3533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1972-740d-b682-55a4bcfa3533",
        "storage_key": "property/6767906449166550/019cfb50-1972-740d-b682-55a4bcfa3533.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16504592488182224350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-central",
      "poi_latitude": "37.6952972",
      "poi_longitude": "-97.2664031",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-681-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4G50TTjuocR3pWuRGwXDOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87d3421a-420a-48dd-b14b-8c352869275f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wichita Barber Company",
      "poi_type": "Health and Wellness",
      "poi_address": "1640 E 2nd St N, Wichita, KS 67214, USA",
      "poi_short_description": "Barber shop offering haircuts, shaves, and VIP treatments in an environment with a vibe.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://wichitabarbercompany.booksy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12079813653761229796&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-barber-company",
      "poi_latitude": "37.6899721",
      "poi_longitude": "-97.3177637",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-304-3868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_sikvnjuocR5ANaOYQepKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_6e82e5fb-5b00-4311-8a14-4d268d96f232",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop East Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "505 S Woodlawn St, Wichita, KS 67207, USA",
      "poi_short_description": "Barbershop offering haircuts with appointments recommended.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-east-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=12886161975853718998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-east-wichita",
      "poi_latitude": "37.6789511",
      "poi_longitude": "-97.2626463",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-400-5697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9AOcbL9uocR1h3oEAvY1LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_79d2fba5-1dd0-4d78-a009-feab5198456c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Classy Nails and Spa Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "2413 N Greenwich Rd Ste 111, Wichita, KS 67226, USA",
      "poi_short_description": "Clean nail salon offering gel manicures and pedis as well as eyelash extensions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-19c8-720e-a2f1-3461f2f616c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-19c8-720e-a2f1-3461f2f616c4",
        "storage_key": "property/6767906449166550/019cfb50-19c8-720e-a2f1-3461f2f616c4.webp",
        "width": 1096,
        "height": 841
      },
      "poi_business_url": "http://classynailsspawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5720972690523935251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "classy-nails-and-spa-wichita",
      "poi_latitude": "37.7267288",
      "poi_longitude": "-97.2087584",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-977-8864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwYliLD9uocRE9Jj3Fn6ZE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_a1016dc2-669a-4ca5-99eb-085c02bc3302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "UrgentPet Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11110 E 26th St N Suite 600, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-19e2-7495-8723-3f216115b779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-19e2-7495-8723-3f216115b779",
        "storage_key": "property/6767906449166550/019cfb50-19e2-7495-8723-3f216115b779.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://urgentpetvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10243324419205437497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urgentpet-care",
      "poi_latitude": "37.7331206",
      "poi_longitude": "-97.2090998",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-440-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSvzoXb9uocRORjTrUmZJ44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ccf7d52b-5c4a-43cd-b2c1-e3233e2daea5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "801 E Douglas Ave #104, Wichita, KS 67202, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-19c3-75fe-86e0-25f027b5e973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-19c3-75fe-86e0-25f027b5e973",
        "storage_key": "property/6767906449166550/019cfb50-19c3-75fe-86e0-25f027b5e973.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ks/wichita/801-e-douglas-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11453330972909731744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "37.685733",
      "poi_longitude": "-97.3285086",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-558-3319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCXuoFZXjuocRoH9DZ9Zn8p4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_016653ba-6e02-44bb-98c5-97d23e4eb907",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wesley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "550 N Hillside St Main Entrance, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f2bc-71d8-8e42-e531c7aceebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f2bc-71d8-8e42-e531c7aceebd",
        "storage_key": "property/6767906449166550/019cfb4f-f2bc-71d8-8e42-e531c7aceebd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wesleymc.com/locations/wesley-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17159963175428114376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wesley-medical-center",
      "poi_latitude": "37.6964068",
      "poi_longitude": "-97.2983475",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-962-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe14-76eb-99e7-d9b0c0d5e77e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe14-76eb-99e7-d9b0c0d5e77e",
        "storage_key": "property/6767906449166550/019cfb4f-fe14-76eb-99e7-d9b0c0d5e77e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxK-0xHjuocRyEctNpdvJO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_06d0f60a-e268-444c-a245-b23758ddb7ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "929 St Francis, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1b98-727d-8caa-98870c72d41e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1b98-727d-8caa-98870c72d41e",
        "storage_key": "property/6767906449166550/019cfb50-1b98-727d-8caa-98870c72d41e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-francis?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408748786587986507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-francis",
      "poi_latitude": "37.6994424",
      "poi_longitude": "-97.3324685",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe14-76eb-99e7-d9b0c0d5e77e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe14-76eb-99e7-d9b0c0d5e77e",
        "storage_key": "property/6767906449166550/019cfb4f-fe14-76eb-99e7-d9b0c0d5e77e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQufU8jjuocRS-oyiRWWt-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ea028dca-de38-4fbd-98b6-e7d32637a355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Great Plains Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6232 East 29th St N #2200, Wichita, KS 67220, USA",
      "poi_short_description": "Indoor-outdoor facilities designed to educate about the flora & fauna of the Great Plains.",
      "poi_long_description": "People say this nature preserve offers beautiful walking trails, diverse wildlife viewing, and opportunities to connect with nature. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails with informative signage. They also like the friendly people and the availability of benches for observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f2bc-71d8-8e42-eb8ee6002871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f2bc-71d8-8e42-eb8ee6002871",
        "storage_key": "property/6767906449166550/019cfb4f-f2bc-71d8-8e42-eb8ee6002871.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://gpnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028016397833359637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-plains-nature-center",
      "poi_latitude": "37.73924",
      "poi_longitude": "-97.263722",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-683-5499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe23-700e-bab8-cc06188f2b15",
        "storage_key": "property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcw5n0z9uocRFVH-Zv7zbt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_fe90d509-faa4-4561-9196-3359b1732201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Fairmount Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1647 N Yale Blvd, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious park featuring a playground, a splash fountain and a community center.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Fairmount-Park-37",
      "poi_directions_map_url": "https://maps.google.com/?cid=11580955339775493795&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fairmount-park",
      "poi_latitude": "37.7127054",
      "poi_longitude": "-97.29159",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe23-700e-bab8-cc06188f2b15",
        "storage_key": "property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3aE5LuLiuocRo0b74oXRt6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_14c41175-7332-4e5d-81a8-c553f44a1e68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Edgemoor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5815 E 9th St N, Wichita, KS 67208, USA",
      "poi_short_description": "Park featuring a splash pad and skate park along with basketball and tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f300-72ab-8449-13e1513fc2eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f300-72ab-8449-13e1513fc2eb",
        "storage_key": "property/6767906449166550/019cfb4f-f300-72ab-8449-13e1513fc2eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Edgemoor-Park-20",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777509089755302817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edgemoor-park",
      "poi_latitude": "37.70038470000001",
      "poi_longitude": "-97.2688025",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe23-700e-bab8-cc06188f2b15",
        "storage_key": "property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxST4RjLjuocRoYv49zhCFM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c6b3ed68-3911-43fb-91da-9d7860c8576a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "L.W. Clapp Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4611 E Harry St, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1cbb-705f-991e-b4e76c3e486a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1cbb-705f-991e-b4e76c3e486a",
        "storage_key": "property/6767906449166550/019cfb50-1cbb-705f-991e-b4e76c3e486a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/LW-Clapp-Memorial-Park-162",
      "poi_directions_map_url": "https://maps.google.com/?cid=11495452650844501100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lw-clapp-park",
      "poi_latitude": "37.6623254",
      "poi_longitude": "-97.2828208",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-688-9341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe23-700e-bab8-cc06188f2b15",
        "storage_key": "property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5z3WKLkuocRbLToyUcNiJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fe92302c-30c4-4a21-9e42-6e8bf0f4cec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "MacDonald Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 N Yale Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_long_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichita.gov/facilities/facility/details/MacDonald-Golf-Course-149",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364549608739728143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "macdonald-golf-course",
      "poi_latitude": "37.6986098",
      "poi_longitude": "-97.2919043",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-688-9391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe29-707f-ab43-dabe73516ed7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe29-707f-ab43-dabe73516ed7",
        "storage_key": "property/6767906449166550/019cfb4f-fe29-707f-ab43-dabe73516ed7.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJATNFVBjjuocRD2ug5Fu0l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_b1a6e7a3-e742-4dff-8395-025395f5ec86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Colonel James Jabara Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3512 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f5ed-77a2-80fa-556ebe990de7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f5ed-77a2-80fa-556ebe990de7",
        "storage_key": "property/6767906449166550/019cfb4f-f5ed-77a2-80fa-556ebe990de7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywichita.com/general-aviation-jabara/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4247184628307720702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colonel-james-jabara-airport",
      "poi_latitude": "37.747501",
      "poi_longitude": "-97.221107",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-636-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-016d-76cd-afec-dbccc2d52024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-016d-76cd-afec-dbccc2d52024",
        "storage_key": "property/6767906449166550/019cfb50-016d-76cd-afec-dbccc2d52024.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QXGMHj9uocR_vnHueoH8To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3310c507-d1b1-4969-ad39-47d334a2b38c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Beech Factory Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9709 E Central Ave, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f6cd-735f-8c40-222dac5b17f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f6cd-735f-8c40-222dac5b17f0",
        "storage_key": "property/6767906449166550/019cfb4f-f6cd-735f-8c40-222dac5b17f0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.beechcraft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405539519632020958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beech-factory-airport",
      "poi_latitude": "37.694119",
      "poi_longitude": "-97.222706",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-016d-76cd-afec-dbccc2d52024.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-016d-76cd-afec-dbccc2d52024",
        "storage_key": "property/6767906449166550/019cfb50-016d-76cd-afec-dbccc2d52024.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2fuq2D8uocR3pXUsHIxYiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7b858ce3-7bdd-4c86-9059-56c09847b9d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Koch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4111 E 37th St N, Wichita, KS 67220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f7d0-7219-971a-06e93620f00d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f7d0-7219-971a-06e93620f00d",
        "storage_key": "property/6767906449166550/019cfb4f-f7d0-7219-971a-06e93620f00d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.kochinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12365933933611970858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "koch",
      "poi_latitude": "37.7515586",
      "poi_longitude": "-97.2902548",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-828-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTHmrtrjuocRKvHjJGWfnKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_33e38498-5f6b-471e-9a96-7413fa20b809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Cargill Protein Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "825 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1d9e-71b1-b207-8ad97d495afc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1d9e-71b1-b207-8ad97d495afc",
        "storage_key": "property/6767906449166550/019cfb50-1d9e-71b1-b207-8ad97d495afc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cargill.com/page/cargill-protein-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=1167281867094812957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cargill-protein-headquarters",
      "poi_latitude": "37.6853999",
      "poi_longitude": "-97.3279603",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-291-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWVDpXjuocRHenwcKwEMxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_32748906-aa99-44c6-9c9e-c8fbdb1cf601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Textron Aviation Career & Learning Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "293 S Greenwich Rd Suite 400, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://txtav.com/en/careers/career-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17738308330864323395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-career--learning-center",
      "poi_latitude": "37.6827328",
      "poi_longitude": "-97.2112662",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-515-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6sjFQD9uocRQyuFAXIhK_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fbe91ede-e408-4d50-a787-73bc82934fea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Airbus Americas Engineering",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1855 Innovation Blvd, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-1dce-7379-a4b4-ab7d03178661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-1dce-7379-a4b4-ab7d03178661",
        "storage_key": "property/6767906449166550/019cfb50-1dce-7379-a4b4-ab7d03178661.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.airbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2717662062190135635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbus-americas-engineering",
      "poi_latitude": "37.717177",
      "poi_longitude": "-97.2864877",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-299-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw6cW5d3iuocRUwlmLD8TtyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_75da5687-8f1e-491c-9162-57c045e195be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Goodwill Industries of Kansas Administration & NexStep Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3351 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-f8e7-7033-9365-ace0311af34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-f8e7-7033-9365-ace0311af34b",
        "storage_key": "property/6767906449166550/019cfb4f-f8e7-7033-9365-ace0311af34b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://goodwillks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600486553204831060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodwill-industries-of-kansas-administration--nexstep-alliance",
      "poi_latitude": "37.744572",
      "poi_longitude": "-97.2273",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-744-9291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXAYzXD9uocRVDP0_r3IFiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_166dfb5e-e6d1-4bb4-ad87-80ec01e9ba43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Gammon Elementary School",
      "poi_type": "Education",
      "poi_address": "3240 N Rushwood St, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://gammon.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13503059042279022783&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gammon-elementary-school",
      "poi_latitude": "37.7417843",
      "poi_longitude": "-97.2553336",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-973-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6xGEZ0_9uocRv-AqHKiAZLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7d3edd74-7955-446f-a374-cc7f588b5956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Isely Traditional Magnet Elementary School",
      "poi_type": "Education",
      "poi_address": "5256 N Woodlawn St, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://isely.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12806423506802940445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "isely-traditional-magnet-elementary-school",
      "poi_latitude": "37.7790718",
      "poi_longitude": "-97.2609863",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-973-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-4odWPjiuocRHZoz_lOOubE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e4ba9c31-c10e-4ec3-a23d-f5a9e8c4bacd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wichita Northeast Magnet High School",
      "poi_type": "Education",
      "poi_address": "5550 N Lycee St, Bel Aire, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://northeast.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15660671500643582661&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-northeast-magnet-high-school",
      "poi_latitude": "37.7849345",
      "poi_longitude": "-97.2386567",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-973-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU3XdLukCu4cRxcLxi8HhVdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_223df3da-b5fa-4c45-94cc-83e54b964086",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Butler Community College of Andover",
      "poi_type": "Education",
      "poi_address": "5000 Building, 715 E 13th St Room 5012, Andover, KS 67002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-bbb1-756d-8836-ef34a54c80ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bbb1-756d-8836-ef34a54c80ff",
        "storage_key": "property/6767906449166550/019d7915-bbb1-756d-8836-ef34a54c80ff.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.butlercc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8602806853151487120&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "butler-community-college-of-andover",
      "poi_latitude": "37.7074517",
      "poi_longitude": "-97.1275701",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-321-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_X9HUBr_uocRkPRj2UBPY3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b6f11062-6daa-4310-ac80-21b841605552",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Fizz Burgers & Bottles",
      "poi_type": "Restaurants",
      "poi_address": "7718 E 37th St N, Wichita, KS 67226, USA",
      "poi_short_description": "Cool joint for scratch-made burgers & hearty sandwiches, plus specialty sodas, wine & bottled beers.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and outstanding sweet potato fries. They highlight the variety of dipping sauces and the kind, attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-b9d1-70b7-b210-82ac7628e928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b9d1-70b7-b210-82ac7628e928",
        "storage_key": "property/6767906449166550/019d7915-b9d1-70b7-b210-82ac7628e928.webp",
        "width": 480,
        "height": 534
      },
      "poi_business_url": "https://www.fizzburgersandbottles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2810319287464352303&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fizz-burgers-bottles",
      "poi_latitude": "37.7529319",
      "poi_longitude": "-97.247837",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-260-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1d432V79uocRL9q9koBCACc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_8099fc19-09aa-40a1-bf81-052ad8d5ee4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Paris Baguette",
      "poi_type": "Restaurants",
      "poi_address": "9780 E 21st St N, Wichita, KS 67226, USA",
      "poi_short_description": "Korean bakery cafe showcasing French-style loaves and pastries along with coffees and teas.",
      "poi_long_description": "People say this bakery offers a wide variety of fresh, flavorful pastries, including sweet and savory options, as well as sandwiches and coffee. They also highlight the clean and inviting atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-c370-730d-88b3-512e751e63e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c370-730d-88b3-512e751e63e6",
        "storage_key": "property/6767906449166550/019d7915-c370-730d-88b3-512e751e63e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parisbaguette.com/locations/ks/wichita/9780-e-21st-st-n/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11652641239537657175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "paris-baguette",
      "poi_latitude": "37.7234332",
      "poi_longitude": "-97.2238727",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-358-7580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23WX9bn9uocRV6W1EXh_tqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_86e9395f-19f2-4f58-92e7-7b12cb1c22e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Blue Hook Cajun Seafood & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2244 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Seafood establishment known for gumbo, crawfish boils, and other Cajun staples in casual digs.",
      "poi_long_description": "Diners say this seafood restaurant serves up delicious seafood boils, crab legs, and red beans and rice. They also highlight the friendly and attentive service, reasonable prices, and quick service.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-cbf4-713b-808d-4c20a420b4ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cbf4-713b-808d-4c20a420b4ae",
        "storage_key": "property/6767906449166550/019d7915-cbf4-713b-808d-4c20a420b4ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bluehookks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7063139586642908144&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blue-hook-cajun-seafood-bar",
      "poi_latitude": "37.724135",
      "poi_longitude": "-97.2254559",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-260-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bOHC5T9uocR8JPZLAhQBWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_66119821-d94f-42f5-a019-c1a233832154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Los Compadres Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "3213 N Toben St, Wichita, KS 67226, USA",
      "poi_short_description": "Family-owned Mexican restaurant providing an all-you-can-eat option for breakfast, lunch, and dinner.",
      "poi_long_description": "People say this restaurant serves delicious enchiladas, fajitas, and tamales. They also highlight the good value, fun vibe with live music, and quick service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-cf76-72a1-a3a4-24ff2ff42446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cf76-72a1-a3a4-24ff2ff42446",
        "storage_key": "property/6767906449166550/019d7915-cf76-72a1-a3a4-24ff2ff42446.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://loscompadreswichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6652550010760686390&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "los-compadres-mexican-grill",
      "poi_latitude": "37.7412719",
      "poi_longitude": "-97.2295101",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-253-0618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF4Ulg_79uocRNmvp8fyaUlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_38d6ca15-19e8-4d4d-9cca-ea452100af1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Hog Wild Pit Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "3550 N Woodlawn Blvd #100, Wichita, KS 67220, USA",
      "poi_short_description": "Counter-serve BBQ chain serving ribs, brisket & pulled pork in a low-key atmosphere.",
      "poi_long_description": "People say this barbecue restaurant serves delicious pulled pork sandwiches, ribs, and loaded potatoes. They also highlight the fast service and reasonable prices.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-d06a-76c3-abd9-161b35f45282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d06a-76c3-abd9-161b35f45282",
        "storage_key": "property/6767906449166550/019d7915-d06a-76c3-abd9-161b35f45282.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hogwildpitbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456046073824439714&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hog-wild-pit-bar-b-q",
      "poi_latitude": "37.74828",
      "poi_longitude": "-97.261719",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-684-1945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQXvl1P9uocRom2w3ZdX9i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_8a84db54-727e-4d2f-b98a-928231ea8d79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Jimmie's Diner",
      "poi_type": "Restaurants",
      "poi_address": "3111 N Rock Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Old-fashioned diner dishing up classic American breakfasts, burgers, soda-fountain treats & more.",
      "poi_long_description": "Diners say this American restaurant serves delicious meatloaf, shakes, and chicken strips, and they praise the friendly and quick service. They also highlight the nostalgic and fun atmosphere, reminiscent of classic diners from the 1950s and 1960s, with reasonable prices.\n\nSome reviews mention the food can be average.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-d688-746a-bade-d624479ff35f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d688-746a-bade-d624479ff35f",
        "storage_key": "property/6767906449166550/019d7915-d688-746a-bade-d624479ff35f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://jimmiesdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17230461748315192024&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jimmie-s-diner",
      "poi_latitude": "37.7398122",
      "poi_longitude": "-97.2450063",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-636-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUShR8kH9uocR2HpIUKvlHu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f9080953-6b8e-4260-af21-08ccd6b0df03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "El Agave",
      "poi_type": "Restaurants",
      "poi_address": "3236 N Rock Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Homestyle Mexican fare & margaritas in an upbeat setting with painted chairs & arched doorways.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, enchiladas, and margaritas. They also highlight the generous portions, affordable prices, and attentive service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-da13-712b-8162-cdfb5f98676b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-da13-712b-8162-cdfb5f98676b",
        "storage_key": "property/6767906449166550/019d7915-da13-712b-8162-cdfb5f98676b.webp",
        "width": 1280,
        "height": 1170
      },
      "poi_business_url": "https://elagavewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1472878520362743504&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-agave",
      "poi_latitude": "37.7408691",
      "poi_longitude": "-97.2440307",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-315-0351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwGTg0L9uocR0DaG6zW3cBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7b119751-f9f5-4dbf-b315-bb024db45f20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wasabi East",
      "poi_type": "Restaurants",
      "poi_address": "3242 N Rock Rd #112, Wichita, KS 67226, USA",
      "poi_short_description": "Inventive rolls & Japanese mains on offer in this relaxed sushi house with beer, wine & sake.",
      "poi_long_description": "People say this sushi restaurant serves delicious sushi, including the Ahi Tower and Coconut Gigolo rolls. They highlight the reasonable prices compared to other sushi restaurants and the pleasant atmosphere. They also like the kind and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-e157-70bc-bc87-6ae5b0f19d11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e157-70bc-bc87-6ae5b0f19d11",
        "storage_key": "property/6767906449166550/019d7915-e157-70bc-bc87-6ae5b0f19d11.webp",
        "width": 1179,
        "height": 1179
      },
      "poi_business_url": "https://us.orderspoon.com/wasabieast",
      "poi_directions_map_url": "https://maps.google.com/?cid=9020500997320397972&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wasabi-east",
      "poi_latitude": "37.741761",
      "poi_longitude": "-97.243237",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-201-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZBewGn9uocRlNRWSd1BL30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_32863fb4-7091-4b68-8ed4-8f987d6f8831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Mulligan's Pub",
      "poi_type": "Restaurants",
      "poi_address": "8343 E 32nd St N, Wichita, KS 67226, USA",
      "poi_short_description": "Casual pub with a jukebox, beer selection, and pizza, plus trivia nights and karaoke.",
      "poi_long_description": "People say this restaurant offers good food, including a cheeseburger pizza, and well-priced drinks. They also highlight the friendly staff, welcoming atmosphere, and fun karaoke.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-e1ed-72b2-a174-04d646031d04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e1ed-72b2-a174-04d646031d04",
        "storage_key": "property/6767906449166550/019d7915-e1ed-72b2-a174-04d646031d04.webp",
        "width": 764,
        "height": 530
      },
      "poi_business_url": "http://mulligansict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212648157130127538&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mulligan-s-pub",
      "poi_latitude": "37.742511",
      "poi_longitude": "-97.240161",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-636-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe18-77ed-a73f-ac0c86a60e25",
        "storage_key": "property/6767906449166550/019cfb4f-fe18-77ed-a73f-ac0c86a60e25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXWGD2n9uocRsviRJMsKfKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_05cfb867-3712-45e4-8c98-504035e986db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "8121 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop offers delicious coffee, breakfast, and lunch options. They highlight the modern design, clean and efficient service, and fast drive-thru. They also like the friendly, welcoming, and genuine staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-e92e-74e8-a1a2-e52377ff23dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e92e-74e8-a1a2-e52377ff23dc",
        "storage_key": "property/6767906449166550/019d7915-e92e-74e8-a1a2-e52377ff23dc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14682949136546956775&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "37.7226",
      "poi_longitude": "-97.43714",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-803-1152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7916-0f54-725b-9326-8a03821e146e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-0f54-725b-9326-8a03821e146e",
        "storage_key": "property/6767906449166550/019d7916-0f54-725b-9326-8a03821e146e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7a4VDgDhuocR54UCM3JQxMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_a9480cf0-604c-4560-beb2-733c62ad648b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Bradley Fair Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "2132 N Rock Rd Suite 102, Wichita, KS 67206, USA",
      "poi_short_description": "50+ specialty retailers & dining options surrounded by gardens, fountains & walking paths.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops and restaurants, including popular brands and a health food store. They highlight the beautiful, clean, and serene atmosphere, with a lake, waterfall, and fountain area, perfect for walking and enjoying the outdoors. They also like the helpful and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-e791-7059-9e2a-b18b36d00b63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e791-7059-9e2a-b18b36d00b63",
        "storage_key": "property/6767906449166550/019d7915-e791-7059-9e2a-b18b36d00b63.webp",
        "width": 737,
        "height": 429
      },
      "poi_business_url": "https://bradleyfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9706768168830484013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bradley-fair-shopping-center",
      "poi_latitude": "37.7178207",
      "poi_longitude": "-97.2438013",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-630-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-4dfd8edcb7c2",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpbwJrhj9uocRLb41jDhetYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e6c49a88-c448-4a0a-8dd4-3490b8362d57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Greenwich Place Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "2716 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Strip mall containing World Market, DSW, and other stores, plus a public restroom.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and restaurants. They highlight the clean, modern, and open layout, as well as the easy access and convenient parking. They also like the fresh, growing-city energy and the overall vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-e917-7656-8bc6-3ef3ad9d1316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e917-7656-8bc6-3ef3ad9d1316",
        "storage_key": "property/6767906449166550/019d7915-e917-7656-8bc6-3ef3ad9d1316.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://greenwichplace.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9972836624592790341&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greenwich-place-shopping-center",
      "poi_latitude": "37.7323509",
      "poi_longitude": "-97.2037438",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-4dfd8edcb7c2",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh_6yd7z9uocRRePbWxKiZoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_acb6cd60-a08d-431a-aea7-3c4dc8716d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Restaurants",
      "poi_address": "9700 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including groceries, household goods, clothing, and tires. They highlight the great value, with many items available in bulk and at competitive prices, and the clean, well-organized layout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-ea6b-7365-bab7-db17c0bea8bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ea6b-7365-bab7-db17c0bea8bb",
        "storage_key": "property/6767906449166550/019d7915-ea6b-7365-bab7-db17c0bea8bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/wichita-KS-1200.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10259352436359460336&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "37.6802342",
      "poi_longitude": "-97.2237745",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-226-7142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe2d-763c-8545-4dfd8edcb7c2",
        "storage_key": "property/6767906449166550/019cfb4f-fe2d-763c-8545-4dfd8edcb7c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE-QgDYf8uocR8HW-Oq-KYI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_5bc4b651-8a53-4e82-bdd4-26685ad3e401",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Bowlero Northrock",
      "poi_type": "Entertainment",
      "poi_address": "3232 N Rock Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Bowling alley & arcade games.",
      "poi_long_description": "People say this bowling alley offers a wide selection of lanes, bowling balls, and shoes, and has a restaurant with plenty of food options. They also highlight the friendly and helpful staff, and the fun and spacious atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-ef88-75fc-881c-9afd3787bbc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ef88-75fc-881c-9afd3787bbc8",
        "storage_key": "property/6767906449166550/019d7915-ef88-75fc-881c-9afd3787bbc8.webp",
        "width": 1280,
        "height": 500
      },
      "poi_business_url": "https://www.bowlero.com/location/bowlero-northrock?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451703492999555049&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bowlero-northrock",
      "poi_latitude": "37.7404433",
      "poi_longitude": "-97.2424088",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-636-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52Uf9Gn9uocR6af-SHFXqEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_b1861d77-c4b3-4c6c-a042-5cac7e3dd590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "AMC Northrock 14",
      "poi_type": "Entertainment",
      "poi_address": "3151 N Penstemon St, Wichita, KS 67226, USA",
      "poi_short_description": "Movie theater chain with a variety of amenities, including reclining seats and 3D movies.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and a good selection of concessions. They also highlight the clean theaters, friendly staff, and powerful sound system.\n\nOther reviews mention the concession prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-f329-759b-a048-7f2a29eaefd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f329-759b-a048-7f2a29eaefd1",
        "storage_key": "property/6767906449166550/019d7915-f329-759b-a048-7f2a29eaefd1.webp",
        "width": 1280,
        "height": 833
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/wichita/amc-northrock-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529197710045147743&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-northrock-14",
      "poi_latitude": "37.740462",
      "poi_longitude": "-97.240899",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-221-7267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7916-102d-76ed-b51e-6c3c6571905a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-102d-76ed-b51e-6c3c6571905a",
        "storage_key": "property/6767906449166550/019d7916-102d-76ed-b51e-6c3c6571905a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQ2wKmr9uocRX_JE86Jdwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a035d3c6-a380-46f6-968d-fb4acd18e284",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Tunnel of Trees",
      "poi_type": "Entertainment",
      "poi_address": "3238 N Oliver Ave, Wichita, KS 67220, USA",
      "poi_short_description": "Tree-covered hiking spot with a tunnel-like trail for scenic walks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-f55d-732f-b061-dc2a1a658efb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f55d-732f-b061-dc2a1a658efb",
        "storage_key": "property/6767906449166550/019d7915-f55d-732f-b061-dc2a1a658efb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16607217575555927319&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tunnel-of-trees",
      "poi_latitude": "37.7429924",
      "poi_longitude": "-97.2714819",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ020Sv8LjuocRF42iamWweOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_efe1fa4e-aad3-4d5f-81ec-99caeb3b8013",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "The Keeper of the Plains",
      "poi_type": "Entertainment",
      "poi_address": "339 Veterans Pkwy, Wichita, KS 67203, USA",
      "poi_short_description": "Blackbear Bosin's 44-ft. Indian chief statue stands at a confluence reachable by 2 footbridges.",
      "poi_long_description": "People say this tourist attraction offers a beautiful sculpture, walking trails, and informative displays about Native American history. They highlight the peaceful and calming vibe, with Native American music playing in the background, and the nightly fire ceremony. They also like the free parking and the opportunity to see the statue lit up at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-f91c-73c8-873e-171dfc9fdfc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f91c-73c8-873e-171dfc9fdfc6",
        "storage_key": "property/6767906449166550/019d7915-f91c-73c8-873e-171dfc9fdfc6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15472396629777065084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-keeper-of-the-plains",
      "poi_latitude": "37.6913539",
      "poi_longitude": "-97.3497162",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-268-4497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0FhzdjjuocRfCTQLcL-uNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_e14d46d5-a4e5-4ad7-a2fe-9f3dfabe303f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Old Cowtown Museum",
      "poi_type": "Entertainment",
      "poi_address": "1865 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Re-creation of late-1880s life in the County, including farm animals, photos & document archives.",
      "poi_long_description": "People say this museum offers a fun and educational experience with live demonstrations, interactive exhibits, and a glimpse into the past. They highlight the self-paced tours, the opportunity to explore historic buildings, and the entertaining gunfights and shows. They also like the knowledgeable and friendly staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7915-facc-7678-bcce-68a6b6c673c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-facc-7678-bcce-68a6b6c673c1",
        "storage_key": "property/6767906449166550/019d7915-facc-7678-bcce-68a6b6c673c1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.oldcowtown.org/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13259083149142063349&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-cowtown-museum",
      "poi_latitude": "37.6936698",
      "poi_longitude": "-97.3601599",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-350-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe20-77b6-a94c-0de6aa2f8b58",
        "storage_key": "property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYk8gGThuocR9fj639-5Abg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b93e5875-2485-498e-acec-19eb501fab08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Central Riverside Park",
      "poi_type": "Entertainment",
      "poi_address": "720 Nims, Wichita, KS 67203, USA",
      "poi_short_description": "Large park featuring a miniature zoo, playgrounds, a splash pad, walking paths & picnic areas.",
      "poi_long_description": "People say this city park offers a playground, splash pad, and walking paths along the river. They highlight the refreshing water park, the nature exhibit with wildlife, and the beautiful gazebo. They also like the rentable games and the friendly geese.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7916-000b-772d-b67c-5370b621c97a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-000b-772d-b67c-5370b621c97a",
        "storage_key": "property/6767906449166550/019d7916-000b-772d-b67c-5370b621c97a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Central-Riverside-Park-43",
      "poi_directions_map_url": "https://maps.google.com/?cid=10285259190793395628&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-riverside-park",
      "poi_latitude": "37.6970794",
      "poi_longitude": "-97.3466547",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe23-700e-bab8-cc06188f2b15",
        "storage_key": "property/6767906449166550/019cfb4f-fe23-700e-bab8-cc06188f2b15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJicxOUdfjuocRrN0Pir2UvI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_91dbca4e-6dd5-4a76-ac7f-8492ad33e526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wichita Country Club",
      "poi_type": "Entertainment",
      "poi_address": "8501 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7916-04d8-723b-8987-4e9b4b629e97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-04d8-723b-8987-4e9b4b629e97",
        "storage_key": "property/6767906449166550/019d7916-04d8-723b-8987-4e9b4b629e97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichitacountryclub.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3671096512194745230&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-country-club",
      "poi_latitude": "37.705606",
      "poi_longitude": "-97.2364611",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-634-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1b-7150-8224-b8e8d9ef48ee",
        "storage_key": "property/6767906449166550/019cfb4f-fe1b-7150-8224-b8e8d9ef48ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwwyR-b8uocRjhOL2dNa8jI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_50904905-582b-4ac5-8a95-1988f0eb24c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Ulrich Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "Wichita State University, 1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "Extensive university contemporary & modern art museum with a large outdoor sculpture collection.",
      "poi_long_description": "Extensive university contemporary & modern art museum with a large outdoor sculpture collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019d7916-06f8-7416-8990-ff57dcdace39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-06f8-7416-8990-ff57dcdace39",
        "storage_key": "property/6767906449166550/019d7916-06f8-7416-8990-ff57dcdace39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ulrich.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3929304075782209670&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ulrich-museum-of-art",
      "poi_latitude": "37.7170582",
      "poi_longitude": "-97.2968079",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-978-3664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe20-77b6-a94c-0de6aa2f8b58",
        "storage_key": "property/6767906449166550/019cfb4f-fe20-77b6-a94c-0de6aa2f8b58.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwHC9uTiuocRhkB-Ez2xhzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_4860ac8a-8e11-4cd1-b8f5-1c5c3a804bb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Northrock Center",
      "poi_type": "Restaurants",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "northrock-center",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_32ac9646-e223-4a47-9e6f-2cf63561c89a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "AMC Theatre",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "amc-theatre",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_93bcf84e-27e3-4a0c-80ae-d9667d6223ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "All Star Adventures",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "all-star-adventures",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_50c7d67b-53a4-4d1f-a324-12f96d971135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Steampunk Village",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "steampunk-village",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6f1d303e-4d56-4990-b6cf-282e40fc1609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Jackson Elementary School",
      "poi_type": "Education",
      "poi_address": "2717 N Woodlawn St, Wichita, KS 67220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe9-0f87-7630-b7b5-e56bb37a79ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe9-0f87-7630-b7b5-e56bb37a79ce",
        "storage_key": "property/6767906449166550/019dbbe9-0f87-7630-b7b5-e56bb37a79ce.webp",
        "width": 615,
        "height": 459
      },
      "poi_business_url": "http://jackson.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8621890333831384454&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jackson-elementary-school",
      "poi_latitude": "37.7346007",
      "poi_longitude": "-97.2648446",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 316-973-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD6lpyEr9uocRhs1k8JMbp3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0860619a-2377-44a3-8335-a4bd3f239061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Brooks STEM and Arts Magnet Middle School",
      "poi_type": "Education",
      "poi_address": "3802 E 27th St N, Wichita, KS 67220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe9-0fc7-7448-a61e-c5d665b3e126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe9-0fc7-7448-a61e-c5d665b3e126",
        "storage_key": "property/6767906449166550/019dbbe9-0fc7-7448-a61e-c5d665b3e126.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.usd259.org/Brooks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2388738444192773027&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brooks-stem-and-arts-magnet-middle-school",
      "poi_latitude": "37.7347559",
      "poi_longitude": "-97.2909415",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 316-973-6450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpRB6h5PiuocRo_Nte_WAJiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7ebab171-a4a4-4056-a73d-17f9d0a95b48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Stucky",
      "poi_type": "Education",
      "poi_address": "4545 Broadview Cir, Wichita, KS 67220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://stucky.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2851284141479440007&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stucky",
      "poi_latitude": "37.76438",
      "poi_longitude": "-97.288085",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 316-973-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxUNDWgdu4cRhy6W5tHLkSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3d712848-3753-4633-9947-1036743c3f6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "poi_name": "Wichita Heights High School",
      "poi_type": "Education",
      "poi_address": "5301 N Hillside St, Wichita, KS 67219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.usd259.org/Heights",
      "poi_directions_map_url": "https://maps.google.com/?cid=1845228234757208164&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-heights-high-school",
      "poi_latitude": "37.7797355",
      "poi_longitude": "-97.3001917",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 316-973-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-fe1f-762f-a73f-c049f6e7fa4f",
        "storage_key": "property/6767906449166550/019cfb4f-fe1f-762f-a73f-c049f6e7fa4f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe09kRQkdu4cRZHg5lk2Rmxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "ec_27c88995217d3e845ac69547",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_740d7b01c907f062a7e23f32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0e7fe0e30fd8e41d105c722a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_93205564951f750792ea99d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2d0622e998625246c8c52894",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c83e92ad87695d3d2ea5796e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e34addb4-658f-4c06-8e9f-cc61980d290b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "rating": "5.0",
      "name": "Maria Huckabee",
      "text": "My air conditioner went out and they acted quickly! They made sure I had a portable air conditioner unit overnight and the next day they were able to fix the issue. Very friendly and helpful staff.",
      "date": "2025-08-16",
      "title": ""
    },
    {
      "id": "custom_7387386e-a958-4e49-91ff-323efe4c142b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "rating": "5.0",
      "name": "Susan Ragias",
      "text": "Renewing my lease was such a positive experience. When I felt helpless navigating electronically, Catherine was so helpful, patient and kind !!!! She was also highly professional and friendly.\nThank You Catherine for going the extra mile !!!! .\n\nAlways timely when maintenance is requested. Highly professional and friendly. Can always count on the maintenance team to get things done correctly.",
      "date": "2025-03-09",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4b4113f7-85bf-4958-b734-19c86aa462a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb50-28cd-76a6-903f-34537a4339a9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of an apartment complex pool area with lounge chairs and buildings in the background.",
        "public_id": "019cfb50-28cd-76a6-903f-34537a4339a9",
        "storage_key": "property/6767906449166550/019cfb50-28cd-76a6-903f-34537a4339a9.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Villas of Waterford Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=60c8c6c5e93f7004c948dfc0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b5-9bd6-773e-8baf-29e6511e650c",
      "lead_source": "LANDING_PAGE",
      "name": "case-villas-of-waterford-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550"
    },
    {
      "lead_collector_id": "019cf79d-4341-7667-839f-a46cbac3af44",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "villas-of-waterford",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-wichita-KS",
      "search_query": "pet friendly apartments Wichita KS",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Wichita, KS",
      "h2_subtitle": "Discover pet-friendly living at Villas of Waterford in Wichita. Our community is the perfect home for you and your furry companions.",
      "page_copy": "At the Villas of Waterford, we understand how important pets are to their families. That's why we proudly offer pet-friendly apartments ensuring that your furry friends are more than welcome in our vibrant community. Situated in the bustling city of Wichita, KS, our modern living spaces offer everything you and your pets could ask for, including expansive outdoor areas and a welcoming environment.\n\nOur pet-friendly apartments in Wichita, KS, boast amenities designed with both residents and pets in mind. Enjoy playtime in our outdoor areas or unwind in the comfort of our plush carpeted living rooms with your pet by your side. We welcome you to explore all that the Villas of Waterford has to offer, from spacious floor plans to community-centric amenities like the Grill & Chill area, perfect for relaxing evenings with your companions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Wichita, KS",
      "seo_description": "Experience pet-friendly living at Villas of Waterford in Wichita, KS. Spacious floor plans and welcoming community for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "apartments-with-pools-sedgwick-county",
      "search_query": "apartments with pools in Sedgwick County",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Sedgwick County",
      "h2_subtitle": "Enjoy resort-style living with two outdoor pools at the Villas of Waterford. Located in Sedgwick County, dive into relaxation and comfort.",
      "page_copy": "Nestled in the heart of Sedgwick County, the Villas of Waterford offers residents the ultimate aquatic leisure experience with two splendid outdoor swimming pools. Revitalize yourself each day with a refreshing dip, or simply lounge poolside as you soak up the enticing Kansas sun. Our pools are more than just a spot to swim; they're a haven for relaxation and community enjoyment.\n\nWith the luxury of pools right at your doorstep, the Villas of Waterford provides an unmatched residential experience in Sedgwick County. Beyond the pools, our community includes other amenities like our inviting Grill & Chill area and a modern resident clubhouse, ensuring that you have everything you need to live comfortably and entertain easily. Discover why our apartments with pools make the perfect home in Wichita and the surrounding Sedgwick County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Sedgwick County",
      "seo_description": "Discover Villas of Waterford in Sedgwick County with two outdoor pools and quality amenities for the ultimate living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-K-96",
      "search_query": "fitness center apartments near K-96",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near K-96",
      "h2_subtitle": "Find your home at Villas of Waterford, ideally located near K-96. Enjoy active living in our dynamic community close to everything you need.",
      "page_copy": "The Villas of Waterford offer an unparalleled living experience near K-96, combining the convenience of urban accessibility with the tranquility of a suburban retreat. Our community is a perfect choice for those seeking apartments with proximity to fitness and wellness opportunities. While we don't have an on-site fitness center, our residents enjoy easy access to a variety of fitness facilities and scenic outdoor areas, making an active lifestyle accessible and convenient.\n\nLocated just a short drive from K-96, the Villas of Waterford places you near an array of local fitness centers and outdoor attractions. With our expansive amenities, including two swimming pools and a vibrant community setting, you can maintain an active and healthy lifestyle right at home. Discover the exceptional living environment that awaits at the Villas of Waterford, where your health and wellness are supported by our ideal location and welcoming community spirit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near K-96",
      "seo_description": "Villas of Waterford near K-96 offers easy access to fitness centers and outdoor activities, complemented by our community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-playground-wichita",
      "search_query": "family friendly apartments with playground Wichita",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments in Wichita",
      "h2_subtitle": "Discover family-friendly living at the Villas of Waterford in Wichita. Perfectly designed for families, explore our welcoming community today.",
      "page_copy": "Experience the perfect environment for your family at the Villas of Waterford, a community that embraces family-friendly living in the heart of Wichita. While our focus extends beyond just having a playground, our vibrant community is designed to be a welcoming space for families to thrive together. With spacious one and two-bedroom apartments, everyone in the family can enjoy their own space and comfort.\n\nOur family-oriented community features two outdoor swimming pools and a vibrant resident clubhouse, ideal for gatherings and social events. Situated in an accessible location in Wichita, KS, we provide a lifestyle that supports both relaxation and activity. Whether enjoying our plush carpeting interiors or spending time outdoors in nearby recreational areas, the Villas of Waterford ensures that each family member finds joy in everyday living. Make us your family's new home in Wichita!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments in Wichita",
      "seo_description": "Discover family-friendly living at Villas of Waterford, Wichita, with spacious apartments and amenities perfect for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "luxury-apartments-clubhouse-wichita",
      "search_query": "luxury apartments with clubhouse in Wichita",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Clubhouse",
      "h2_subtitle": "Villas of Waterford in Wichita offers luxurious apartment living with an elegant clubhouse. Experience the best in comfort and community.",
      "page_copy": "Welcome to the Villas of Waterford, where luxury meets community in the vibrant city of Wichita. Our luxury apartments are designed to provide you with unparalleled comfort and style, featuring modern amenities like vaulted ceilings and plush carpeting. One of our standout features is our elegant resident clubhouse, a hub for connection and entertainment.\n\nThe clubhouse at the Villas of Waterford offers residents a sophisticated environment to relax, socialize, and host events. Whether you're unwinding after a long day or gathering with friends and neighbors, our clubhouse provides the perfect setting. Coupled with our two outdoor swimming pools and the convenience of an Internet Cafe, our community boasts everything you need for a luxurious lifestyle in Wichita. Discover the exceptional living experience that awaits you at the Villas of Waterford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Clubhouse in Wichita",
      "seo_description": "Experience luxury at Villas of Waterford in Wichita, complete with an elegant clubhouse and modern amenities for a sophisticated lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-wichita-ks",
      "search_query": "one bedroom apartments in Wichita KS",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Wichita KS",
      "h2_subtitle": "Discover one bedroom living at Villas of Waterford in Wichita, KS. Perfectly designed for comfort and convenience.",
      "page_copy": "At the Villas of Waterford, our one bedroom apartments are perfect for those seeking comfort and modern amenities in Wichita, KS. Each apartment features premium details like plush carpeting and vaulted ceilings that add a touch of elegance to your living space. Designed with convenience and style in mind, these one bedroom layouts offer a cozy retreat with ample room to live and unwind.\n\nLocated in a prime area in Wichita, KS, the Villas of Waterford not only offer stunning apartment features but also boast a community that enhances your lifestyle. Enjoy access to two outdoor swimming pools, a vibrant resident clubhouse, and a grill area with a fireplace. Nestled near essential local amenities and cultural spots, our one bedroom apartments are ideally situated to provide you with the best of Wichita city living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Wichita KS",
      "seo_description": "Explore one bedroom apartments at Villas of Waterford in Wichita, KS. Enjoy modern living with elegant features and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-sedgwick-county",
      "search_query": "two bedroom floorplans in Sedgwick County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans Available",
      "h2_subtitle": "Villas of Waterford offers spacious two-bedroom floorplans in Sedgwick County. Ideal for families and roommates seeking comfort.",
      "page_copy": "Explore the spacious two bedroom floorplans offered at Villas of Waterford, located in the heart of Sedgwick County. Each apartment is thoughtfully designed to provide ample space and comfort, featuring elegant vaulted ceilings and plush carpeting that enhance the living experience. Our two bedroom layouts are perfect whether you're a family, roommates, or simply need extra space for your lifestyle.\n\nIn addition to exquisite interiors, our community amenities elevate everyday life. Residents enjoy access to two beautiful outdoor swimming pools and a vibrant resident clubhouse, perfect for both relaxation and entertainment. Nestled in a prime Sedgwick County location, Villas of Waterford places you close to local conveniences, making it easy to enjoy everything the area has to offer while experiencing the best of apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans in Sedgwick County",
      "seo_description": "Discover spacious two bedroom floorplans at Villas of Waterford in Sedgwick County. Experience elegant living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "apartments-near-wichita-state-university",
      "search_query": "apartments near Wichita State University Wichita",
      "category": "School",
      "h1_title": "Apartments Near Wichita State University",
      "h2_subtitle": "Find your perfect home at Villas of Waterford, located conveniently near Wichita State University in Wichita.",
      "page_copy": "The Villas of Waterford offers the perfect solution for those seeking apartments near Wichita State University in Wichita. Our community is ideal for students, faculty, and staff who want the convenience of a short commute without sacrificing the comforts of home. With spacious one and two-bedroom floor plans, you'll find plenty of room to make yourself comfortable.\n\nBeyond the proximity to Wichita State University, the Villas of Waterford boasts exceptional amenities. Dive into one of our two refreshing outdoor swimming pools, connect with neighbors at our vibrant resident clubhouse, or stay connected at our Internet Cafe. Set in a peaceful neighborhood, yet close to the energetic university environment, our community strikes the perfect balance between academic and personal pursuits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wichita State University",
      "seo_description": "Discover Villas of Waterford apartments near Wichita State University. Enjoy spacious living and modern amenities just minutes from WSU.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "villas-near-woolsey-hall-67226",
      "search_query": "Villas close to Woolsey Hall 67226",
      "category": "School",
      "h1_title": "Villas Close to Woolsey Hall, 67226",
      "h2_subtitle": "Discover Villas of Waterford, located near Woolsey Hall in the vibrant 67226 area. Experience convenience and modern living.",
      "page_copy": "Located in the bustling area of 67226, the Villas of Waterford offers modern living near Woolsey Hall, making it a prime choice for those seeking convenience. Whether you are a student, faculty, or professional, our attractive one and two-bedroom apartments provide the perfect mix of comfort and style, featuring vaulted ceilings and plush carpeting.\n\nApart from the proximity to Woolsey Hall, residents of the Villas of Waterford enjoy a variety of community amenities, such as two outdoor swimming pools, a resident clubhouse, and a grill & chill area with a fireplace. Our pet-friendly atmosphere ensures all members of your family are welcome. With our ideal location and modern conveniences, discover the perfect place to call home in 67226.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Villas Close to Woolsey Hall, 67226",
      "seo_description": "Explore Villas of Waterford, located near Woolsey Hall in 67226. Enjoy spacious apartments and exceptional community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "apartments-near-wesley-medical-center-wichita",
      "search_query": "apartments near Wesley Medical Center Wichita",
      "category": "Hospital",
      "h1_title": "Apartments Near Wesley Medical Center",
      "h2_subtitle": "Find convenient living at Villas of Waterford, located near Wesley Medical Center in Wichita. Comfortable and accessible.",
      "page_copy": "For those seeking comfortable and accessible living, the Villas of Waterford offers ideal apartments near Wesley Medical Center in Wichita. Our community provides a perfect spot for medical professionals, patients, and families who want ease of access and a welcoming home environment. Choose from spacious one and two-bedroom floor plans, each designed to maximize comfort.\n\nResiding close to Wesley Medical Center, residents enjoy numerous community amenities, enhancing everyday life. Dip into our outdoor swimming pools, meet new friends in our resident clubhouse, or stay connected in our Internet Cafe. Located in Wichita, these homes strike the perfect balance between proximity to key healthcare facilities and the tranquility of a welcoming neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wesley Medical Center",
      "seo_description": "Discover Villas of Waterford, convenient apartments near Wesley Medical Center in Wichita. Enjoy spacious floor plans and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "villas-of-waterford-near-ascension-via-christi-st-francis",
      "search_query": "Villas of Waterford near Ascension Via Christi St. Francis KS",
      "category": "Hospital",
      "h1_title": "Villas of Waterford near Ascension Via Christi",
      "h2_subtitle": "Discover easy living at Villas of Waterford, conveniently situated near Ascension Via Christi St. Francis in KS.",
      "page_copy": "Experience unparalleled convenience at the Villas of Waterford, located near Ascension Via Christi St. Francis in Kansas. Our community is an excellent choice for healthcare professionals and patients alike, offering a perfect blend of accessibility and comfort in spacious one and two-bedroom apartment homes. Enjoy features such as vaulted ceilings and plush carpeting.\n\nWith our prime location, residents can quickly access Ascension Via Christi St. Francis while enjoying an array of on-site amenities. Whether you choose to relax by one of our two outdoor swimming pools or engage with fellow residents in our vibrant clubhouse, Villas of Waterford ensures a comfortable and welcoming environment. Discover the convenience and quality of life offered in our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Villas of Waterford near Ascension Via Christi",
      "seo_description": "Explore Villas of Waterford, ideally located near Ascension Via Christi St. Francis, KS. Enjoy modern amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-nature-center-wichita",
      "search_query": "apartments near Great Plains Nature Center Wichita",
      "category": "Park",
      "h1_title": "Apartments Near Great Plains Nature Center",
      "h2_subtitle": "Discover Villas of Waterford, conveniently located near Great Plains Nature Center in Wichita for nature enthusiasts.",
      "page_copy": "Embrace the beauty of nature with a home at the Villas of Waterford, offering top-notch apartments near the Great Plains Nature Center in Wichita. Our community is perfect for those who appreciate both comfort and easy access to breathtaking outdoor spaces. Choose from well-designed one and two-bedroom floor plans, featuring modern amenities that make everyday living a pleasure.\n\nSituated close to the Great Plains Nature Center, residents at the Villas of Waterford can enjoy all that nature has to offer while taking full advantage of our community facilities. From relaxing by our outdoor swimming pools to engaging in community activities at the resident clubhouse, there's something for everyone. Discover a harmonious lifestyle that brings nature close to home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Great Plains Nature Center",
      "seo_description": "Live at Villas of Waterford, apartments near Great Plains Nature Center in Wichita. Enjoy spacious living with nature's charm nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "apartments-close-to-fairmount-park-ks",
      "search_query": "apartments close to Fairmount Park KS",
      "category": "Park",
      "h1_title": "Apartments Close to Fairmount Park",
      "h2_subtitle": "Live close to Fairmount Park at the Villas of Waterford, offering modern and spacious living in Wichita, KS.",
      "page_copy": "Enjoy the vibrant outdoor lifestyle with the Villas of Waterford, offering exceptional apartments close to Fairmount Park in Wichita, KS. Perfect for families, young professionals, and anyone who savors park-side living, our community provides one and two-bedroom options that blend modern comfort with proximity to beautiful green spaces.\n\nBeing minutes away from Fairmount Park allows residents to immerse themselves in recreational activities while savoring the comforts of home. Indulge in our community's amenities such as outdoor swimming pools, a grill & chill area with a fireplace, and plush interiors designed for relaxation. With quick access to Fairmount Park, Villas of Waterford ensures a balanced and enriching lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Fairmount Park, KS",
      "seo_description": "Experience Villas of Waterford, where modern living meets nature. Conveniently located close to Fairmount Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "edgemoor-park-nearby-apartments-sedgwick-county",
      "search_query": "Edgemoor Park nearby apartments Sedgwick County",
      "category": "Park",
      "h1_title": "Edgemoor Park Nearby Apartments",
      "h2_subtitle": "Explore Villas of Waterford, the ideal community with nearby access to Edgemoor Park in Sedgwick County.",
      "page_copy": "Discover a perfect living environment at the Villas of Waterford, offering apartments that are conveniently located near Edgemoor Park in Sedgwick County. Our community is an exceptional choice for those who appreciate being in close proximity to recreational areas while residing in thoughtfully designed one and two-bedroom homes.\n\nWith Edgemoor Park just a short distance away, our residents have access to a variety of outdoor activities and green spaces. Meanwhile, the on-site amenities at Villas of Waterford include two outdoor swimming pools and an internet cafe, ensuring a lifestyle of convenience and relaxation. Enjoy the perfect balance of nature and modern living at our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Edgemoor Park Nearby Apartments",
      "seo_description": "Live at Villas of Waterford, offering comfortable apartments near Edgemoor Park in Sedgwick County. Enjoy a vibrant and connected lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166550",
      "source": "generator",
      "page_item_url": "lw-clapp-park-area-apartments-wichita-67226",
      "search_query": "L.W. Clapp Park area apartments Wichita 67226",
      "category": "Park",
      "h1_title": "L.W. Clapp Park Area Apartments",
      "h2_subtitle": "Villas of Waterford offers spacious living options near L.W. Clapp Park in the 67226 area of Wichita.",
      "page_copy": "Welcome to the Villas of Waterford, where you'll find delightful apartments near the L.W. Clapp Park area in Wichita, 67226. Our community provides the perfect home base for those seeking a harmonious blend of modern amenities and access to beautiful outdoor spaces in a sought-after neighborhood.\n\nChoose from our wide selection of spacious one and two-bedroom floor plans, complemented by community perks like vaulted ceilings and a pet-friendly atmosphere. Living near L.W. Clapp Park means easy access to enjoyable amenities such as playgrounds and trails, creating a wonderful environment for all ages. Discover your ideal lifestyle close to the action yet nestled in serenity at the Villas of Waterford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
      "featured_image_media": {
        "alt_text": "A beautifully furnished bedroom with a queen-sized bed, teal bedding, wooden furniture, and white curtains.",
        "public_id": "019dbbe8-ff32-707c-bd8b-53b84381625e",
        "storage_key": "property/6767906449166550/019dbbe8-ff32-707c-bd8b-53b84381625e.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "L.W. Clapp Park Area Apartments",
      "seo_description": "Explore Villas of Waterford, offering spacious apartments in Wichita's 67226, near L.W. Clapp Park. Enjoy convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5228"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-R9PQW9KHVG"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128853216"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/villas-of-waterford/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K8T3DFPQ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449166550/019d1bd6-73a4-74b0-b226-0529378558d5.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-958-4649"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "66573fd2ade3f953f2cd9aaf"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjZZVkl4Z1N4SUhqem13eUdtSEsyTkE9PSIsInZhbHVlIjoiQ2wrZWhkanRHRzdkMTdxdE9NZEdGQT09IiwibWFjIjoiMzFhMDIxZjZjMzQzOTcxYzgyN2I3ZjQzZTVlNjU4Y2Y2MWNkNjVmZDNjYTBiNGRmMjE0Y2VjZjkxNDFjYWI1OCJ9"
    }
  ],
  "custom_qb_id": "5228",
  "custom_ga4_id": "G-R9PQW9KHVG",
  "custom_repli_id": "18128853216",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/villas-of-waterford/register/",
  "custom_google_gtm_id": "GTM-K8T3DFPQ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449166550/019d1bd6-73a4-74b0-b226-0529378558d5.pdf",
  "custom_ppc_tracking_phone_number": "855-958-4649",
  "custom_residentboost_apartment_id": "66573fd2ade3f953f2cd9aaf",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjZZVkl4Z1N4SUhqem13eUdtSEsyTkE9PSIsInZhbHVlIjoiQ2wrZWhkanRHRzdkMTdxdE9NZEdGQT09IiwibWFjIjoiMzFhMDIxZjZjMzQzOTcxYzgyN2I3ZjQzZTVlNjU4Y2Y2MWNkNjVmZDNjYTBiNGRmMjE0Y2VjZjkxNDFjYWI1OCJ9"
};

export const generatedAt = '2026-08-27T21:34:06.739Z';
